<template>
  <div class="card-create-box" style="padding-left:42px">
    <IsChildren />
    <div class="cc-box" style="padding-left:20px">
      <CContainer>
        <div>
          <TextScroll :isVis="isVis" :dataList="textArr" @handlerNotice="getAnnouncement"></TextScroll>
        </div>
        <CRow>
          <CCol md="6" sm="4">
            <div class="cc-title-box">
              <div class="title">{{ $t('VirtualCard.Create.CreateANewCard') }}</div>
              <!-- <a style="color: #1675D4;margin-left:10px;margin-top:12px" :href="`${ori}/user-guide/${getLa}/virtual-card-operation/CreateCard.html`" target="_blank">{{ $t('VirtualCard.Create.Guide') }}</a> -->
              <a style="color: #1675D4;margin-left:10px;margin-top:12px" :href="getLa == 'tw' ? 'https://www.youtube.com/watch?v=HLh9SlDMbcI' : 'https://www.youtube.com/watch?v=Zd_Y1ikvAYA'" target="_blank">{{ $t('VirtualCard.Create.Guide') }}</a>
            </div>

            <div class="cc-input-box">
              <CRow>
                <CCol>
                  <CForm>
                    <div>
                      <!-- <CSelect
                        label="BIN"
                        :options="options"
                        placeholder="請選擇卡段"
                        v-model="selectCard"
                        @change="getSelectCard"
                      /> -->
                      <label style="font-weight: bold">BIN
                        <a :href="toMer" target="_blank" class="tomerchant"><small>{{ $t('VirtualCard.Create.BinGuide') }}</small></a>
                      </label>

                      <div class="search-bin-box">
                        <div class="sb-item">
                          <!-- <span>地区</span> -->
                          <el-select size="mini" v-model="binObj.binRegion" @change="handlerBinRegion" style="font-size:12px;width:120px">
                            <el-option :label="$t('VirtualCard.Create.AllRegion')" value="AllRegion" style="font-size:12px">{{ $t('VirtualCard.Create.AllRegion') }}</el-option>
                            <el-option :label="$t('VirtualCard.Create.UnitedState')" value="US">
                              <span><CIcon name="cifUs" style="width:1.2rem;height:1.2rem" /></span>
                              <span style="font-size:12px;padding-left:5px">{{ $t('VirtualCard.Create.UnitedState') }}</span>
                            </el-option>
                            <el-option :label="$t('VirtualCard.Create.HongKong')" value="HK">
                              <span>
                                <svg style="width:1.2rem;height:1.2rem" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 900 600" role="img">undefined<g fill="none"><path fill="#DE2910" d="M0 0h900v600H0z"></path><path fill="#FFF" d="M449.964 299.913c-105.263-44.486-58.602-181.581 42.07-174.69-20.366 10.467-23.318 29.997-11.687 48.09 13.024 20.256-1.2 52.848-18.806 60.767-28.935 13.025-34.728 47.75-11.577 65.833z"></path><path fill="#DE2910" d="M444.272 200.92l-5.92 9.294-2.144-10.815-10.679-2.759 9.625-5.39-.671-10.999 8.085 7.49 10.256-4.043-4.61 10.01 7.001 8.505-10.943-1.293zm6.288 97.839c-12.731-6.534-22.996-20.155-27.468-36.431-5.115-18.67-2.173-38.743 8.083-55.038l-2.208-1.394c-10.64 16.929-13.693 37.743-8.386 57.12 4.728 17.221 15.214 31.097 28.787 38.064l1.192-2.321z"></path><path fill="#FFF" d="M450.072 299.939c9.78-113.858 154.584-111.846 179.14-13.971-16.248-16.135-35.734-12.908-49.348 3.745-15.24 18.646-50.632 15.19-63.604.893-21.329-23.494-56.144-18.273-66.188 9.333z"></path><path fill="#DE2910" d="M542.46 263.935l-10.668-2.758 9.623-5.381-.676-11.01 8.1 7.489 10.254-4.037-4.625 10.004 7.014 8.504-10.944-1.29-5.926 9.286-2.151-10.807zm-91.107 36.214c2.28-14.127 12.063-28.099 26.16-37.381 16.176-10.634 36.175-14.04 54.842-9.32l.644-2.531c-19.389-4.888-40.127-1.36-56.916 9.675-14.917 9.818-24.874 24.08-27.305 39.14l2.575.417z"></path><path fill="#FFF" d="M450.08 300.05c111.308-25.883 154.14 112.456 68.645 166.055 10.324-20.44 1.233-37.975-18.811-45.776-22.443-8.732-30.093-43.46-20.504-60.215 15.753-27.545.029-59.043-29.33-60.065z"></path><path fill="#DE2910" d="M512.872 376.79l-.674-10.998 8.092 7.49 10.26-4.046-4.618 10.018 7.008 8.504-10.943-1.307-5.921 9.3-2.154-10.809-10.663-2.765 9.613-5.386zm-62.596-75.457c14.14-2.197 30.451 2.79 43.636 13.328 15.112 12.098 24.53 30.067 25.811 49.278l2.606-.17c-1.343-19.95-11.107-38.583-26.79-51.14-13.947-11.153-30.587-16.216-45.663-13.874l.4 2.578z"></path><path fill="#FFF" d="M449.978 300.092c59.011 97.862-59.32 181.347-136.716 116.599 22.63 3.502 36.497-10.563 37.722-32.037 1.37-24.042 32.034-42.05 50.932-38.107 31.065 6.47 56.163-18.218 48.062-46.455z"></path><path fill="#DE2910" d="M396.396 383.524l10.253-4.04-4.623 10.01 7.018 8.51-10.955-1.297-5.922 9.293-2.139-10.812-10.673-2.758 9.613-5.388-.665-10.996 8.093 7.478zm52.422-82.85c6.459 12.77 6.757 29.823.808 45.62-6.836 18.11-21.015 32.62-38.89 39.775l.967 2.426c18.559-7.442 33.263-22.487 40.359-41.282 6.297-16.711 5.97-34.1-.916-47.715l-2.328 1.177z"></path><path fill="#FFF" d="M449.906 300.007c-74.837 86.364-190.803-.377-153.14-93.993 3.662 22.604 21.324 31.447 42.125 25.976 23.29-6.127 49.89 17.472 51.982 36.663 3.446 31.544 34.681 47.784 59.033 31.354z"></path><path fill="#DE2910" d="M354 274.83l7.009 8.503-10.948-1.303-5.924 9.303-2.152-10.82-10.668-2.76 9.622-5.375-.676-11.003 8.095 7.478 10.253-4.03-4.612 10.007zm94.993 24.254c-10.149 10.089-26.275 15.642-43.136 14.866-19.337-.905-37.519-9.906-49.847-24.695l-2.008 1.669c12.813 15.35 31.665 24.686 51.733 25.626 17.84.825 34.277-4.86 45.097-15.615l-1.84-1.851z"></path></g></svg>
                              </span>
                              <span style="font-size:12px;padding-left:5px">{{ $t('VirtualCard.Create.HongKong') }}</span>
                            </el-option>
                            <el-option :label="$t('VirtualCard.Create.Singapore')" value="SGP">
                              <!-- <span><CIcon name="cifSg" style="width:1.2rem;height:1.2rem" /></span> -->
                              <svg style="width:1.2rem;height:1.2rem" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 301 201" role="img">undefined<g fill="none"><path fill="#ED2939" d="M.5.5h300v100H.5z"></path><path fill="#FFF" d="M.5 100.5h300v100H.5zM103.395 50.5c0 20.768-16.836 37.604-37.604 37.604S28.187 71.268 28.187 50.5s16.836-37.604 37.604-37.604c20.767 0 37.604 16.836 37.604 37.604z"></path><path fill="#ED2939" d="M115.211 50.5c0 19.627-15.911 35.537-35.537 35.537-19.626 0-35.537-15.911-35.537-35.537 0-19.627 15.911-35.537 35.537-35.537 19.626 0 35.537 15.91 35.537 35.537z"></path><path fill="#FFF" d="M70.444 51.407l-5.108-3.919-5.107 3.921 1.966-6.319-5.125-3.895 6.324.013 1.94-6.328 1.942 6.327 6.323-.016-5.123 3.897zM110.527 51.407l-5.108-3.919-5.107 3.921 1.966-6.319-5.125-3.895 6.324.013 1.94-6.328 1.942 6.327 6.323-.016-5.123 3.897zM90.506 36.531l-5.108-3.919-5.107 3.921 1.966-6.319-5.125-3.895 6.323.013 1.94-6.328 1.942 6.327 6.324-.016-5.123 3.897zM77.944 75.209l-5.108-3.919-5.107 3.921 1.966-6.319-5.125-3.895 6.324.013 1.94-6.328 1.942 6.327 6.323-.016-5.123 3.897zM103.027 75.209l-5.108-3.919-5.107 3.921 1.966-6.319-5.125-3.895 6.324.013 1.94-6.328 1.942 6.327 6.323-.016-5.123 3.897z"></path></g></svg>
                              <span style="font-size:12px;padding-left:5px">{{ $t('VirtualCard.Create.Singapore') }}</span>
                            </el-option>
                            <el-option :label="$t('VirtualCard.Create.UnitedKingdom')" value="UK">
                              <!-- <span><CIcon name="cifSg" style="width:1.2rem;height:1.2rem" /></span> -->
                              <svg style="width:1.2rem;height:1.2rem;" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 301 151" role="img">undefined<g fill="none"><path fill="#FFF" d="M.5.5h299.843v149.983H.5z"></path><path fill="#CF142B" d="M135.428 90.444v60.039h29.988V90.444h134.928V60.46H165.416V.5h-29.988v59.96H.5v29.984z"></path><path fill="#00247D" d="M175.415 49.049V.5h97.08zM175.415 101.933v48.55h97.08zM125.428 101.933v48.55H28.349zM125.428 49.049V.5H28.349zM.501 14.442v36.051h72.087zM300.343 14.442v36.051h-72.087zM300.343 136.541V100.49h-72.087zM.501 136.541V100.49h72.087z"></path><path fill="#CF142B" d="M300.343.5h-16.654L183.9 50.493h16.654L300.5.5M116.943 100.487h-16.654L.5 150.48h16.654l99.946-49.993M83.768 50.532h16.653L.5.5v8.385zM217.023 100.468h-16.654L300.29 150.5v-8.385z"></path></g></svg>
                              <span style="font-size:12px;padding-left:5px">{{ $t('VirtualCard.Create.UnitedKingdom') }}</span>
                            </el-option>
                          </el-select>
                          
                        </div>
                        <div class="sb-item" style="margin-left: 10px">
                          <!-- <span>地区</span> -->
                          <el-select size="mini" v-model="binObj.binBrand" @change="handlerBinBrand" style="font-size:12px;width:120px">
                            <el-option :label="$t('VirtualCard.Create.AllBrand')" value="AllBrand" style="font-size:12px">{{ $t('VirtualCard.Create.AllBrand') }}</el-option>
                            <el-option label="VISA" value="VISA" style="font-size:12px">VISA</el-option>
                            <el-option label="Master" value="Master" style="font-size:12px">Master</el-option>
                            <el-option label="Discover" value="Discover" style="font-size:12px">Discover</el-option>
                          </el-select>
                        </div>
                      </div>

                      <!-- all -->
                      <div class="all" style="display:flex;flex-wrap:wrap" v-if="allVisi">
                        <div style="margin-bottom:10px;" v-for="(item,i) in binArrObj" :key="i">
                          <el-tooltip effect="dark" :content="descriptionInfoShow(item)" placement="top" v-model="item.tip_visi" :manual="true">
                            <button :disabled="item.is_maintain == 1" :style="item.is_maintain == 1?'position:relative;filter:opacity(0.5);background:#eee;cursor:no-drop;':'position:relative'" @mouseover="visiTipHan(i,item)" @mouseleave="hideTipHan(item,i)" type="button" :class="itemIndex == i ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(i,item.bin)">
                              
                              <span :class="item.bin=='472593' ? 'yd-text':''">{{binNameRender(item)}}</span>
                              <sup class="sup-pos" v-if="item.is_maintain == 1">
                                <i style="width:100%;height:100%;font-weight:bold" class="el-icon-video-pause"></i>
                              </sup>
                              <sup class="sup-pos" style="width:15px;height:15px" v-if="item.is_maintain == 2">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1691995907129" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="5881" width="100%" height="100%"><path d="M768.213333 621.269333a201.130667 201.130667 0 0 0-86.485333 12.928c-43.605333-22.4-94.336-33.621333-152.234667-33.621333-82.048 0-149.76 22.485333-203.093333 67.498667-53.290667 45.013333-92.757333 113.578667-118.357333 205.653333-3.456 11.776-10.752 19.2-21.802667 22.314667a26.496 26.496 0 0 1-28.586667-8.277334 28.501333 28.501333 0 0 1-6.741333-29.610666c49.152-173.781333 144.384-276.266667 285.610667-307.413334-47.786667-22.869333-82.901333-56.96-105.386667-102.314666-22.528-45.354667-28.586667-93.994667-18.218667-145.92 12.458667-51.968 38.442667-93.653333 77.909334-125.184 39.466667-31.488 85.504-47.957333 138.154666-49.322667 53.333333 1.365333 99.712 17.834667 139.178667 49.322667 39.466667 31.530667 65.408 73.216 77.866667 125.184 10.410667 51.925333 4.352 100.565333-18.176 145.92-22.485333 45.354667-57.984 79.445333-106.453334 102.314666 56.234667 12.330667 105.130667 35.84 146.773334 70.528z m-239.232-108.970666c46.378667-1.408 84.821333-17.322667 115.285334-47.786667 30.464-30.464 46.378667-68.906667 47.786666-115.285333-1.408-45.696-17.322667-83.797333-47.786666-114.261334-30.464-30.464-68.906667-46.378667-115.285334-47.786666-45.696 1.408-83.797333 17.322667-114.261333 47.786666-30.464 30.464-46.378667 68.565333-47.786667 114.261334 1.408 46.378667 17.322667 84.821333 47.786667 115.285333 30.464 30.464 68.565333 46.378667 114.261333 47.786667z" fill="#617282" p-id="5882"/><path d="M757.333333 941.226667c-84.053333 0-152.32-66.816-152.32-149.333334 0-82.432 68.266667-149.333333 152.32-149.333333 84.181333 0 152.32 66.901333 152.32 149.333333 0 82.517333-68.138667 149.333333-152.32 149.333334z m30.890667-208.341334l-31.573333 57.642667-27.818667-57.898667a23.722667 23.722667 0 0 0-42.752 20.48l47.786667 99.541334c8.32 17.408 32.853333 18.090667 42.112 1.152l53.802666-98.133334a23.722667 23.722667 0 1 0-41.557333-22.784z" fill="#617282" p-id="5883"/></svg>
                              </sup>
                            </button>
                          </el-tooltip>
                          <!-- <el-popover
                            placement="top"
                            title=""
                            popper-class="popper-sty"
                            width="200"
                            v-model="item.showPopper"
                            trigger="click"
                            :content="item.description">
                            <button slot="reference" style="position:relative" @mouseover="visiTipHan(i)" @mouseleave="hideTipHan(item,i)" type="button" :class="itemIndex == i ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(i,item.bin,item)">
                              
                              <span :class="item.bin=='472593' ? 'yd-text':''">{{item.bin == '472593' ? '472593 OR 436797' : item.bin}}</span>
                              <sup class="sup-pos" v-if="item.is_maintain == 1">
                                <i style="width:100%;height:100%;font-weight:bold" class="el-icon-video-pause"></i>
                              </sup>
                              <sup class="sup-pos" style="width:15px;height:15px" v-if="item.is_maintain == 2">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1691995907129" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="5881" width="100%" height="100%"><path d="M768.213333 621.269333a201.130667 201.130667 0 0 0-86.485333 12.928c-43.605333-22.4-94.336-33.621333-152.234667-33.621333-82.048 0-149.76 22.485333-203.093333 67.498667-53.290667 45.013333-92.757333 113.578667-118.357333 205.653333-3.456 11.776-10.752 19.2-21.802667 22.314667a26.496 26.496 0 0 1-28.586667-8.277334 28.501333 28.501333 0 0 1-6.741333-29.610666c49.152-173.781333 144.384-276.266667 285.610667-307.413334-47.786667-22.869333-82.901333-56.96-105.386667-102.314666-22.528-45.354667-28.586667-93.994667-18.218667-145.92 12.458667-51.968 38.442667-93.653333 77.909334-125.184 39.466667-31.488 85.504-47.957333 138.154666-49.322667 53.333333 1.365333 99.712 17.834667 139.178667 49.322667 39.466667 31.530667 65.408 73.216 77.866667 125.184 10.410667 51.925333 4.352 100.565333-18.176 145.92-22.485333 45.354667-57.984 79.445333-106.453334 102.314666 56.234667 12.330667 105.130667 35.84 146.773334 70.528z m-239.232-108.970666c46.378667-1.408 84.821333-17.322667 115.285334-47.786667 30.464-30.464 46.378667-68.906667 47.786666-115.285333-1.408-45.696-17.322667-83.797333-47.786666-114.261334-30.464-30.464-68.906667-46.378667-115.285334-47.786666-45.696 1.408-83.797333 17.322667-114.261333 47.786666-30.464 30.464-46.378667 68.565333-47.786667 114.261334 1.408 46.378667 17.322667 84.821333 47.786667 115.285333 30.464 30.464 68.565333 46.378667 114.261333 47.786667z" fill="#617282" p-id="5882"/><path d="M757.333333 941.226667c-84.053333 0-152.32-66.816-152.32-149.333334 0-82.432 68.266667-149.333333 152.32-149.333333 84.181333 0 152.32 66.901333 152.32 149.333333 0 82.517333-68.138667 149.333333-152.32 149.333334z m30.890667-208.341334l-31.573333 57.642667-27.818667-57.898667a23.722667 23.722667 0 0 0-42.752 20.48l47.786667 99.541334c8.32 17.408 32.853333 18.090667 42.112 1.152l53.802666-98.133334a23.722667 23.722667 0 1 0-41.557333-22.784z" fill="#617282" p-id="5883"/></svg>
                              </sup>
                            </button>
                          </el-popover> -->
                          <!-- <sup class="sup-pos" v-if="item.is_maintain == 1">
                            <img style="width:100%;height:100%" src="../../assets/icon_suspend.png" alt="">
                          </sup> -->
                          <!-- <button v-else type="button" :class="itemIndex == i ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(i,item.bin)">{{item.bin}}</button> -->
                        </div>
                        <!-- <div class="s-btn-box">
                        <button
                          type="button"
                          :class="itemIndex == 7 ? 's-btn s-btn-active' : 's-btn'"
                          style="margin-left: 0px"
                          @click="getIndex(7,529587)"
                        >
                          529587
                        </button>
                        <button type="button" :class="itemIndex == 8 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(8,538738)">538738</button>
                        <button type="button" :class="itemIndex == 9 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(9,526144)">526144</button>
                        <button type="button" :class="itemIndex == 10 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(10,418122)">418122</button>
                      </div>
                      <div class="s-btn-box">
                        <button
                          type="button"
                          :class="itemIndex == 11 ? 's-btn s-btn-active' : 's-btn'"
                          style="margin-left: 0px"
                          @click="getIndex(11,417969)"
                        >
                          417969
                        </button>
                        <button type="button" :class="itemIndex == 2 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(2,472593)">472593</button>
                        <button type="button" :class="itemIndex == 3 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(3,222929)">222929</button>
                        <button
                          type="button"
                          :class="itemIndex == 1 ? 's-btn s-btn-active' : 's-btn'"
                          @click="getIndex(1,222934)"
                        >
                          222934
                        </button>
                      </div>
                      <div class="s-btn-box">
                        <button type="button" style="margin-left: 0px" :class="itemIndex == 6 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(6,557271)">557271</button>
                        <button
                          type="button"
                          :class="itemIndex == 4 ? 's-btn s-btn-active' : 's-btn'"
                        
                          @click="getIndex(4,428837)"
                        >
                          428837
                        </button>
                        <button type="button" :class="itemIndex == 5 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(5,540524)">540524</button>
                        <button type="button" :class="itemIndex == 0 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(0,556766)">556766</button>
                      </div> -->
                      </div>

                      <div v-if="!allVisi">
                        <div class="s-btn-box" style="width:400px;display:flex;flex-wrap:wrap">
                          <!-- <button v-for="(item,index) in xzarr" :key="index" type="button" :class="itemIndex == index&&kq ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(index,item)">{{item}}</button> -->

                          <div style="margin-bottom:10px;" v-for="(item,i) in xzarr" :key="i">
                          <el-tooltip effect="dark" :content="descriptionInfoShow(item)" placement="top" v-model="item.tip_visi" :manual="true">
                            <button :disabled="item.is_maintain == 1" :style="item.is_maintain == 1?'position:relative;filter:opacity(0.5);background:#eee;cursor:no-drop;':'position:relative'" @mouseover="visiTipHan2(i)" @mouseleave="hideTipHan(item,i)" type="button" :class="itemIndex == i ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(i,item.bin)">
                              
                              <span :class="item.bin=='472593' ? 'yd-text':''">{{binNameRender(item)}}</span>
                              <sup class="sup-pos" v-if="item.is_maintain == 1">
                                <i style="width:100%;height:100%;font-weight:bold" class="el-icon-video-pause"></i>
                              </sup>
                              <sup class="sup-pos" style="width:15px;height:15px" v-if="item.is_maintain == 2">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1691995907129" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="5881" width="100%" height="100%"><path d="M768.213333 621.269333a201.130667 201.130667 0 0 0-86.485333 12.928c-43.605333-22.4-94.336-33.621333-152.234667-33.621333-82.048 0-149.76 22.485333-203.093333 67.498667-53.290667 45.013333-92.757333 113.578667-118.357333 205.653333-3.456 11.776-10.752 19.2-21.802667 22.314667a26.496 26.496 0 0 1-28.586667-8.277334 28.501333 28.501333 0 0 1-6.741333-29.610666c49.152-173.781333 144.384-276.266667 285.610667-307.413334-47.786667-22.869333-82.901333-56.96-105.386667-102.314666-22.528-45.354667-28.586667-93.994667-18.218667-145.92 12.458667-51.968 38.442667-93.653333 77.909334-125.184 39.466667-31.488 85.504-47.957333 138.154666-49.322667 53.333333 1.365333 99.712 17.834667 139.178667 49.322667 39.466667 31.530667 65.408 73.216 77.866667 125.184 10.410667 51.925333 4.352 100.565333-18.176 145.92-22.485333 45.354667-57.984 79.445333-106.453334 102.314666 56.234667 12.330667 105.130667 35.84 146.773334 70.528z m-239.232-108.970666c46.378667-1.408 84.821333-17.322667 115.285334-47.786667 30.464-30.464 46.378667-68.906667 47.786666-115.285333-1.408-45.696-17.322667-83.797333-47.786666-114.261334-30.464-30.464-68.906667-46.378667-115.285334-47.786666-45.696 1.408-83.797333 17.322667-114.261333 47.786666-30.464 30.464-46.378667 68.565333-47.786667 114.261334 1.408 46.378667 17.322667 84.821333 47.786667 115.285333 30.464 30.464 68.565333 46.378667 114.261333 47.786667z" fill="#617282" p-id="5882"/><path d="M757.333333 941.226667c-84.053333 0-152.32-66.816-152.32-149.333334 0-82.432 68.266667-149.333333 152.32-149.333333 84.181333 0 152.32 66.901333 152.32 149.333333 0 82.517333-68.138667 149.333333-152.32 149.333334z m30.890667-208.341334l-31.573333 57.642667-27.818667-57.898667a23.722667 23.722667 0 0 0-42.752 20.48l47.786667 99.541334c8.32 17.408 32.853333 18.090667 42.112 1.152l53.802666-98.133334a23.722667 23.722667 0 1 0-41.557333-22.784z" fill="#617282" p-id="5883"/></svg>
                              </sup>
                            </button>
                          </el-tooltip>
                          <!-- <el-popover
                            placement="top"
                            title=""
                            popper-class="popper-sty"
                            width="200"
                            v-model="item.showPopper"
                            trigger="click"
                            :content="item.description">
                            <button slot="reference" style="position:relative" @mouseover="visiTipHan2(i)" @mouseleave="hideTipHan(item,i)" type="button" :class="itemIndex == i ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(i,item.bin,item)">
                              
                              <span :class="item.bin=='472593' ? 'yd-text':''">{{item.bin == '472593' ? '472593 OR 436797' : item.bin}}</span>
                              <sup class="sup-pos" v-if="item.is_maintain == 1">
                                <i style="width:100%;height:100%;font-weight:bold" class="el-icon-video-pause"></i>
                              </sup>
                              <sup class="sup-pos" style="width:15px;height:15px" v-if="item.is_maintain == 2">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1691995907129" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="5881" width="100%" height="100%"><path d="M768.213333 621.269333a201.130667 201.130667 0 0 0-86.485333 12.928c-43.605333-22.4-94.336-33.621333-152.234667-33.621333-82.048 0-149.76 22.485333-203.093333 67.498667-53.290667 45.013333-92.757333 113.578667-118.357333 205.653333-3.456 11.776-10.752 19.2-21.802667 22.314667a26.496 26.496 0 0 1-28.586667-8.277334 28.501333 28.501333 0 0 1-6.741333-29.610666c49.152-173.781333 144.384-276.266667 285.610667-307.413334-47.786667-22.869333-82.901333-56.96-105.386667-102.314666-22.528-45.354667-28.586667-93.994667-18.218667-145.92 12.458667-51.968 38.442667-93.653333 77.909334-125.184 39.466667-31.488 85.504-47.957333 138.154666-49.322667 53.333333 1.365333 99.712 17.834667 139.178667 49.322667 39.466667 31.530667 65.408 73.216 77.866667 125.184 10.410667 51.925333 4.352 100.565333-18.176 145.92-22.485333 45.354667-57.984 79.445333-106.453334 102.314666 56.234667 12.330667 105.130667 35.84 146.773334 70.528z m-239.232-108.970666c46.378667-1.408 84.821333-17.322667 115.285334-47.786667 30.464-30.464 46.378667-68.906667 47.786666-115.285333-1.408-45.696-17.322667-83.797333-47.786666-114.261334-30.464-30.464-68.906667-46.378667-115.285334-47.786666-45.696 1.408-83.797333 17.322667-114.261333 47.786666-30.464 30.464-46.378667 68.565333-47.786667 114.261334 1.408 46.378667 17.322667 84.821333 47.786667 115.285333 30.464 30.464 68.565333 46.378667 114.261333 47.786667z" fill="#617282" p-id="5882"/><path d="M757.333333 941.226667c-84.053333 0-152.32-66.816-152.32-149.333334 0-82.432 68.266667-149.333333 152.32-149.333333 84.181333 0 152.32 66.901333 152.32 149.333333 0 82.517333-68.138667 149.333333-152.32 149.333334z m30.890667-208.341334l-31.573333 57.642667-27.818667-57.898667a23.722667 23.722667 0 0 0-42.752 20.48l47.786667 99.541334c8.32 17.408 32.853333 18.090667 42.112 1.152l53.802666-98.133334a23.722667 23.722667 0 1 0-41.557333-22.784z" fill="#617282" p-id="5883"/></svg>
                              </sup>
                            </button>
                          </el-popover> -->
                          <!-- <sup class="sup-pos" v-if="item.is_maintain == 1">
                            <img style="width:100%;height:100%" src="../../assets/icon_suspend.png" alt="">
                          </sup> -->
                          <!-- <button v-else type="button" :class="itemIndex == i ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(i,item.bin)">{{item.bin}}</button> -->
                        </div>
                          
                          <!-- <button v-for="(item,index) in xzarr" :key="index" type="button" :class="itemIndex == index&&kq ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(index,it.bin)">{{it.bin}}</button> -->
                          




                        <!-- <button
                          v-if="hkBin || masterBin"
                          type="button"
                          :class="itemIndex == 7 ? 's-btn xc s-btn-active' : 's-btn xc'"
                          @click="getIndex(7,529587)"
                        >
                          529587
                        </button>
                        <button v-if="hkBin || masterBin" type="button" :class="itemIndex == 8 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(8,538738)">538738</button>
                        <button v-if="hkBin || masterBin" type="button" :class="itemIndex == 9 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(9,526144)">526144</button>
                        <button v-if="hkBin || visaBin" type="button" :class="itemIndex == 10 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(10,418122)">418122</button>

                        <button
                          v-if="hkBin || visaBin"
                          type="button"
                          :class="itemIndex == 11 ? 's-btn xc s-btn-active' : 's-btn xc'"
                          @click="getIndex(11,417969)"
                        >
                          417969
                        </button>
                        <button v-if="hkBin || visaBin" type="button" :class="itemIndex == 2 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(2,472593)">472593</button>
                        <button v-if="hkBin || masterBin" type="button" :class="itemIndex == 3 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(3,222929)">222929</button>
                        <button
                          v-if="hkBin || masterBin"
                          type="button"
                          :class="itemIndex == 1 ? 's-btn xc s-btn-active' : 's-btn xc'"
                          @click="getIndex(1,222934)"
                        >
                          222934
                        </button>

                        <button v-if="hkBin || masterBin" type="button" :class="itemIndex == 6 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(6,557271)">557271</button>
                        <button
                          type="button"
                          :class="itemIndex == 4 ? 's-btn xc s-btn-active' : 's-btn xc'"
                          v-if="usBin || visaBin"
                          @click="getIndex(4,428837)"
                        >
                          428837
                        </button>
                        <button v-if="usBin || masterBin" type="button" :class="itemIndex == 5 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(5,540524)">540524</button>
                        <button v-if="usBin || masterBin" type="button" :class="itemIndex == 0 ? 's-btn xc s-btn-active' : 's-btn xc'" @click="getIndex(0,556766)">556766</button> -->
                      </div>
                      <!-- <div class="s-btn-box">
                        <button
                          v-show="hkBin || visaBin"
                          type="button"
                          :class="itemIndex == 11 ? 's-btn s-btn-active' : 's-btn'"
                          style="margin-left: 0px"
                          @click="getIndex(11,417969)"
                        >
                          417969
                        </button>
                        <button v-show="hkBin || visaBin" type="button" :class="itemIndex == 2 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(2,472593)">472593</button>
                        <button v-show="hkBin || masterBin" type="button" :class="itemIndex == 3 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(3,222929)">222929</button>
                        <button
                          v-show="hkBin || masterBin"
                          type="button"
                          :class="itemIndex == 1 ? 's-btn s-btn-active' : 's-btn'"
                          @click="getIndex(1,222934)"
                        >
                          222934
                        </button>
                      </div> -->
                      <!-- <div class="s-btn-box">
                        <button v-show="hkBin || masterBin" type="button" style="margin-left: 0px" :class="itemIndex == 6 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(6,557271)">557271</button>
                        <button
                          type="button"
                          :class="itemIndex == 4 ? 's-btn s-btn-active' : 's-btn'"
                          v-show="usBin || visaBin"
                          @click="getIndex(4,428837)"
                        >
                          428837
                        </button>
                        <button v-show="usBin || masterBin" type="button" :class="itemIndex == 5 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(5,540524)">540524</button>
                        <button v-show="usBin || masterBin" type="button" :class="itemIndex == 0 ? 's-btn s-btn-active' : 's-btn'" @click="getIndex(0,556766)">556766</button>
                      </div> -->
                      </div>

                      <!-- 账户余额 -->
                      <div style="" class="acc-balancebox">
                        <div style="font-weight:bold">{{$t('VirtualCard.Create.AccountBalanceDialog.DAB')}}</div>
                        <div style="color:#1675D4;font-size:17px;font-weight:600;">${{account_balance}}</div>
                      </div>

                      <div style="margin-bottom: .3rem">
                        <div style="font-weight:bold">{{$t('VirtualCard.Create.CreateNum')}}
                          <el-tooltip placement="top">
                          <div slot="content">
                            <div>{{$t('VirtualCard.Create.CreateNumTip')}}</div>
                          </div>
                          <i style="cursor:pointer;color:#E6A23C;font-size:18px;vertical-align: -2px" class="el-icon-question"></i>
                        </el-tooltip>
                        <!-- <a href="javascript:;" @click="showDig" style="margin-left:4px" class="tomerchant"><small>{{$t('VirtualCard.Create.PayGuaranteeDeposit')}}</small></a> -->
                        </div>
                        <!-- <div style="font-weight:bold">{{ ctNum }}</div> -->
                        <div v-if="need_guarantee == 1 && primaryMark != '2'" style="margin-top:5px;">
                          <button @click="showDig" class="btn custer sbtn" type="button">{{$t('VirtualCard.Create.PleaseGuaranteeDeposit')}}</button>
                        </div>
                        <div style="margin-top:5px" v-else>
                          <CardNumPrj :a="Number(remaining)" :total="Number(ctNum)"></CardNumPrj>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-for="(item,index) in addData" :key="index">
                      <div>
                        <div style="text-align:right;font-size:22px" @click="deleteItem">×</div>
                      </div>
                      <el-form :model="ival">
                        <el-form-item label="持卡人姓名">
                        <el-input v-model="item.first_name" placeholder="First Name" type="text" />
                        </el-form-item>
                      <el-form-item>
                        <el-input v-model="item.last_name" placeholder="Last Name" type="text" />
                      </el-form-item>
                      <el-form-item label="初始金额">
                        <el-input v-model="item.initAmt" placeholder="初始金额" type="number" />
                       </el-form-item>
                      <el-form-item label="标签">
                        <el-input v-model="item.tag" placeholder="标签" type="text" />
                      </el-form-item>
                    </el-form>
                    
                    </div>
                    <div style="text-align:center">
                      <el-button @click="addItem">继续添加</el-button>
                    </div> -->
                    <!-- <div>
                      <MyAddInput
            v-for="(item, index) in inputVal"
            :key="index"
            :default-value="{ label : item.label, value : item.value }"
            @change="(label, val) => inputChange(label, val, index)"
            @addItem="addItem"
            @deleteItem="() => deleteItem(index)"
          />
                    </div> -->
                    
                   <div v-for="(item,index) in addData" :key="index">
                      <div style="display:flex;align-items:center;">
                        <div v-if="index > 0" class="add-card-item-border"></div>
                        <div v-if="index > 0" style="text-align:right;font-size:22px;cursor: pointer;" @click="deleteItem(index)">×</div>
                      </div>
                      <div style="display:none">
                      <label style="font-weight:bold;margin-bottom:0">{{$t('VirtualCard.Create.CardName')}}</label>
                          <div>
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.CardNameTip')"></el-alert>
                          </div>
                      <div class="cc-ka-box">
                      <CInput
                        v-if="bins == 556766"
                        type="text"
                        style="width:50%"
                        id="exampleFormControlInput1"
                        placeholder="First Name"
                        valid-feedback=""
                        :invalid-feedback="errorBackName556766"
                        :is-valid="validatorName556766"
                        v-model="item.first_name"
                      >
                      <template #label>
                          <!-- <label style="font-weight:bold">{{$t('VirtualCard.Create.CardName')}}</label>
                          <div>
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.CardNameTip')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                      <CInput
                        v-else
                        type="text"
                        style="width:50%"
                        id="exampleFormControlInput1"
                        placeholder="First Name"
                        valid-feedback=""
                        :invalid-feedback="errorBack"
                        :is-valid="validator"
                        v-model="item.first_name"
                      >
                      <template #label>
                          <!-- <label style="font-weight:bold">{{$t('VirtualCard.Create.CardName')}}</label> -->
                          <!-- <div>
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.CardNameTip')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                      <CInput
                        v-if="bins == 556766"
                        type="text"
                        id="exampleFormControlInput2"
                        placeholder="Last Name"
                        style="margin-left: 20px;width:50%"
                        valid-feedback=""
                        :invalid-feedback="errorBackNameL556766"
                        :is-valid="validatorNameL556766"
                        v-model="item.last_name"
                      >
                        <template #label>
                          <!-- <label style="opacity: 0">持卡人</label>
                          <div style="opacity: 0">
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.CardNameTip')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                      <CInput
                        v-else
                        type="text"
                        id="exampleFormControlInput2"
                        placeholder="Last Name"
                        style="margin-left: 20px;width:50%"
                        valid-feedback=""
                        :invalid-feedback="errorBack"
                        :is-valid="validator"
                        v-model="item.last_name"
                      >
                        <template #label>
                          <!-- <label style="opacity: 0">持卡人</label>
                          <div style="opacity: 0">
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.CardNameTip')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                    </div>
                    </div>
                    <!-- 485932 -->
                    <div v-show="bins == 485932">
                      <div style="font-weight:bold">{{$t('VirtualCard.Create.BilliongAddress')}}</div>
                      <div style="display:flex;align-item:center;width:100%">
                        <div style="width:50%">
                          <el-alert style="height:282px;padding-top:0px;padding-bottom:0px" type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.BillingAddress485932')"></el-alert>
                        </div>
                        <div style="width:50%">
                          <!-- <img style="width:100%;height:100%" src="../../assets/485932_tip_img.png" alt=""> -->
                          <el-image fit="fill" style="width:100%;height:100%" :src="require('../../assets/485932_tip_img.png')" :preview-src-list="preList"></el-image>
                        </div>
                      </div>
                    </div>

                    <!-- 556766 -->
                    <div v-show="bins == 556766">
                      <div style="font-weight:bold">{{$t('VirtualCard.Create.BilliongAddress')}}</div>
                      <div class="adt">{{$t('VirtualCard.Create.BAddressTip')}}</div>
                      <CInput
                        type="text"
                        id="exampleFormControlInput1"
                        :placeholder="$t('VirtualCard.Create.BAddressTip')"
                        valid-feedback=""
                        onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'');"
                        v-model="item.billing_address.address"
                      />
                      
                    </div>
                    <div v-show="bins == 556766">
                      <CInput
                        type="text"
                        id="exampleFormControlInput1"
                        add-label-classes="ft"
                        valid-feedback=""
                        onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'');"
                        v-model="item.billing_address.city"
                      >
                      <template #label>
                          <label style="font-weight:bold">{{$t('VirtualCard.Create.City')}}</label>
                        </template>
                      </CInput>
                    </div>
                    <div v-show="bins == 556766">
                      <!-- <CSelect :value="item.billing_address.state" label="洲" @change="getOption" :options="wOption">
                
                      </CSelect> -->
                      <div class="lb" style="font-weight:bold">{{$t('VirtualCard.Create.State')}}</div>
                      <el-select style="width:100%" v-model="item.billing_address.state">
                        <el-option
                          v-for="item in wOption"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>
                    <div v-show="bins == 556766">
                      <CInput
                        type="number"
                        id="exampleFormControlInput1"
                        valid-feedback=""
                        v-model="item.billing_address.zip"
                      >
                      <template #label>
                          <label style="font-weight:bold">{{$t('VirtualCard.Create.ZipCode')}}</label>
                        </template>
                      </CInput>
                    </div>
                    <!--  -->
                    <div v-if="visiOp">
                      <CInput
                        type="text"
                        id="exampleFormControlInput1"
                        :placeholder="$t('VirtualCard.Create.PleaseEnterTheInitialBalance')"
                        valid-feedback=""
                        :invalid-feedback="errorBackAmount"
                        :is-valid="validatorAmount"
                        v-model="item.balance"
                        prepend="$"
                        :disabled="is4725"
                      >
                      <template #label>
                          <label style="font-weight:bold;">{{$t('VirtualCard.Create.InitialBalance')}}</label>
                          <!-- <div>
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.InitialBalanceTitle')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                    </div>
                    <div v-if="bins == 556766">
                      <CInput
                        type="text"
                        id="exampleFormControlInput1"
                        :placeholder="$t('VirtualCard.Create.PleaseEnterTheInitialBalance')"
                        valid-feedback=""
                        :invalid-feedback="errorBackAmount556766"
                        :is-valid="validatorAmount556766"
                        v-model="item.balance"
                        prepend="$"
                        :disabled="false"
                      >
                      <template #label>
                          <label style="font-weight:bold;">{{$t('VirtualCard.Create.InitialBalance')}}</label>
                          <!-- <div>
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.InitialBalanceTitle')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                    </div>

                    <div v-if="tipVis">
                      <CInput
                        type="text"
                        id="exampleFormControlInput1"
                        :placeholder="$t('VirtualCard.Create.PleaseEnterTheInitialBalance')"
                        valid-feedback=""
                        :invalid-feedback="errorBackAmount587_738_144_122"
                        :is-valid="validatorAmount587_738_144_122"
                        v-model="item.balance"
                        prepend="$"
                        :disabled="false"
                      >
                      <template #label>
                          <label style="font-weight:bold;">{{$t('VirtualCard.Create.InitialBalance')}}</label>
                          <!-- <div>
                            <el-alert type="warning" :closable="false" show-icon :title="$t('VirtualCard.Create.InitialBalanceTitle')"></el-alert>
                          </div> -->
                        </template>
                      </CInput>
                    </div>

                    <div>
                      <CInput
                        type="text"
                        :label="$t('VirtualCard.Create.LabelOptional')"
                        add-label-classes="ft"
                        :placeholder="$t('VirtualCard.Create.PleaseEnterTheLabel')"
                        v-model="item.tag"
                        valid-feedback=""
                        :invalid-feedback="errorBackTag"
                        :is-valid="validatorTag"
                      >
                      <template #label>
                          <label style="font-weight:bold">{{$t('VirtualCard.Create.LabelOptional')}}</label>
                        </template>
                      </CInput>
                    </div>
                    <!-- 持卡人 -->
                    <div v-if="supportCardHolder == '1'" style="display:flex;align-items:center;justify-content:space-between;">
                      <label style="font-weight:bold;margin:0">{{$t('VirtualCard.Create.CardHolderOptional')}}
                        <el-tooltip effect="dark" :content="$t('VirtualCard.Create.CardHolderOptionTip')" placement="top">
                          <i class="el-icon-question" style="font-size:18px;margin-left:2px;color:#E6A23C;vertical-align:-2px;"></i>
                        </el-tooltip>
                      </label>
                      <div style="display:flex;align-items:center;">
                        <label style="font-weight:bold;margin:0">{{ item.holder_name_label }}</label>
                        <el-button v-if="item.holder_name_label == '' || item.holder_name_label == undefined" @click="openSelectCardHolderDialog(item,index)" size="small" style="background-color:#00BEA4;color:#fff;margin-left:8px;">{{$t('VirtualCard.Create.CardHolderSelect')}}</el-button>
                        <el-button v-else icon="el-icon-delete" @click="resetCardHolder(item,index)" size="small" style="margin-left:8px;" type="danger"></el-button>
                        
                      </div>
                    </div>

                   </div>
                   <div style="text-align:center" v-if="ifAddMax">
                      <!-- <CButton style="background:#00BEA4;color: #fff" @click="addItem">{{ $t('VirtualCard.Create.AddOne') }}</CButton> -->
                      <button @click="addItem" style="width:82px;" class="cur hv" type="button">{{ $t('VirtualCard.Create.AddOne') }}</button>
                    </div>
                    <!-- 費用 -->
                    <div>
                      <div class="fei-box">{{ $t('VirtualCard.Create.Expenses') }}：</div>

                      <div class="fei-info-box">
                        <CListGroup flush>
                          <CListGroupItem
                            ><div>
                              {{ $t('VirtualCard.Create.InitialBalance') }}：$ {{ getAmount }}
                            </div></CListGroupItem
                          >
                          <CListGroupItem
                            ><div>{{ $t('VirtualCard.Create.CardOpeningFee') }}：$ {{ kaFei }}</div></CListGroupItem
                          >
                          <CListGroupItem
                            ><div>
                              {{ $t('VirtualCard.Create.ValueAddedExpenses') }}：$ {{ AmountFei }}
                            </div></CListGroupItem
                          >
                          <CListGroupItem
                            ><div>{{ $t('VirtualCard.Create.Total') }}：$ {{ Tatol }}</div></CListGroupItem
                          >
                        </CListGroup>
                        <!-- <CCardBody>
                          <CDataTable
                            :hover="hover"
                            :striped="striped"
                            :border="border"
                            :small="small"
                            :fixed="fixed"
                            :items="data"
                            :fields="fields"
                            :items-per-page="small ? 10 : 5"
                            :dark="dark"
                            pagination
                          >
                          </CDataTable>
                        </CCardBody> -->
                        <!-- <div>充值金額：${{Amount}}</div>
                        <div>開卡費：$52</div>
                        <div>充值費用：${{ '20' }}</div>
                        <div>總計：$200</div> -->
                      </div>
                    </div>
                    <div>
                      <CCol>
                        <!-- <CButton
                          color="primary"
                          style="background: #00bea4; border-color: #00bea4"
                          @click="submit"
                          >{{ $t('VirtualCard.Create.Submit') }}</CButton
                        > -->
                        <button v-if="visiOp" :disabled="submitDib" style="width:70px" @click="submit" class="btn custer sbtn" type="button">{{ $t('VirtualCard.Create.Submit') }}</button>
                        <button v-if="tipVis" :disabled="submitDib587_738_144_122" style="width:70px" @click="submit" class="btn custer sbtn" type="button">{{ $t('VirtualCard.Create.Submit') }}</button>
                        <button v-if="bins == 556766" :disabled="submitDib2" style="width:70px" @click="submit" class="btn custer sbtn" type="button">{{ $t('VirtualCard.Create.Submit') }}</button>
                      </CCol>
                    </div>
                    <div>
                      <div style="margin-top:10px">
                        <el-checkbox v-model="checkedRlus">
                          <div style="display:flex;align-items:center;font-size:16px;white-space:pre-line">
                            {{ $t('VirtualCard.Create.SelectedRlus.Cek') }}
                          </div>
                        </el-checkbox>
                        <div v-if="mapType.includes('S')" class="rlusInfo" style="padding-left: 20px;font-size:16px">
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus1') }}</div>
                          </div>
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus2Special') }}</div>
                          </div>
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus3') }}</div>
                          </div>
                        </div>
                        <div v-else class="rlusInfo" style="padding-left: 20px;font-size:16px">
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus1') }}</div>
                          </div>
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus2') }}</div>
                          </div>
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus3') }}</div>
                          </div>
                          <div style="display:flex;align-items:center;padding:5px 0">
                            <i class="el-icon-close" style="color:#FF3B30;font-size:16px"></i><div style="margin-left:5px">{{ $t('VirtualCard.Create.SelectedRlus.Rlus4') }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CForm>
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol md="6" sm="1">
            <transition-group name="animate__animated" appear enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__fadeOutRight">
            <div :key="itemIndex" ref="wbox" class="wrper">
              <div class="card-look-box">
                <div class="card-img-box pst-rl">
                  <div class="pst-box">
                    <div class="cc-title">{{ cardType }}</div>
                    <!-- <div class="cc-number">4725 93** **** **** ****</div> -->
                    <!-- <div class="cc-number" v-if="!kq">{{cb}} {{c2b}}** **** **** ****</div> -->
                    <!-- <div class="cc-number" v-else-if="searching == true">** **** **** ****</div> -->
                    <!-- <div class="cc-number" v-else>{{cb}} {{c2b}}** **** **** ****</div> -->
                    <div v-if="bins == 472593" style="overflow:hidden;height:40px;margin-top:45px">
                      <!-- <div class="cc-number gund" style="margin-top:0">{{cb}} {{c2b}}** **** **** ****</div> -->
                      <!-- <div class="cc-number gund" style="margin-top:0">4367 97** **** **** ****</div> -->
                      <div class="cc-number" style="margin-top:0">4367** **** **** ****</div>
                    </div>
                    <div v-else-if="bins == 486699" style="overflow:hidden;height:40px;margin-top:45px">
                      <div class="cc-number" style="margin-top:0">4866** **** **** ****</div>
                    </div>
                    <div v-else-if="bins == 450306" style="overflow:hidden;height:40px;margin-top:45px">
                      <div class="cc-number" style="margin-top:0">4***** **** **** ****</div>
                    </div>
                    <div v-else-if="bins == 446618" style="overflow:hidden;height:40px;margin-top:45px">
                      <div class="cc-number" style="margin-top:0">4466** **** **** ****</div>
                    </div>
                    <div v-else>
                      <div class="cc-number">{{cb}} {{c2b}}** **** **** ****</div>
                    </div>
                    <!-- <div class="cc-time">22/10</div> -->
                    <div class="cc-name" style="opacity:0">{{ addData[0].first_name }} {{ addData[0].last_name }} </div>
                    <div class="visa-ico2" v-if="picBin">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="120"
                          height="120"
                          viewBox="0 0 32 32"
                          fill="#3C58A5"
                        >
                          <path
                            d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                          />
                        </svg>
                    </div>
                    <!-- <div v-else-if="picBin" class="visa-ico" style="margin-left:380px;margin-top:-30px;">
                      <el-image :src="mc" lazy class="d-block w-100"></el-image>
                    </div> -->
                    <div class="visa-ico" style="margin-left:380px;margin-top:-30px;width:100px;height:100px" v-else>
                      <el-image v-if="bins==658706" :src="discovericon" lazy class="d-block w-100"></el-image>
                      <el-image v-else :src="mc" lazy class="d-block w-100"></el-image>
                     
                    </div>
                  </div>
                  
                  <div v-if="currentCard">
                    <el-image
                      :key="bins"
                      :src="currentCard.src"
                      :style="imageStyle(currentCard)"
                      lazy
                      class="d-block"
                    />
                  </div>

                </div>
                <div class="card-info-box">
                  <div class="cc-info-box" key="0">
                    <div class="cc-with-box s-qu-width">
                      <CRow class="align-items-start">
                        <CCol>
                          <div class="cc-item s-qu-width">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.CardType') }}</div>
                            <div class="cc-item-dec">{{dType}}</div>
                            <!-- <div class="cc-item-dec" v-if="bins == 222929">Master Prepaid</div>
                            <div class="cc-item-dec" v-else-if="bins == 556766">Master Credit(US)</div>
                            <div class="cc-item-dec" v-else-if="bins == 222934">Master Credit(HK)</div>
                            <div class="cc-item-dec" v-else-if="bins == 540524">Master Credit(US)</div>
                            <div class="cc-item-dec" v-else-if="bins == 557271">Master Credit(HK)</div>
                            <div class="cc-item-dec" v-else-if="bins == 428837">Master Credit(US)</div>
                            <div class="cc-item-dec" v-else>VISA Credit(HK)</div> -->
                          </div>
                        </CCol>
                        <CCol>
                          <div class="cc-item s-qu-width">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.Currency') }}</div>
                            <div class="cc-item-dec">USD</div>
                          </div>
                        </CCol>
                        <CCol>
                          <div class="cc-item s-qu-width">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.SingleConsumptionLimit') }}</div>
                            <div class="cc-item-dec" v-if="bins == 556766">$ 500</div>
                            <div class="cc-item-dec" v-else-if="bins == 472593">$ 100,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 450306">$ 50,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 446618">$ 50,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 493724">$ 50,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 529587">$ 350</div>
                            <div class="cc-item-dec" v-else-if="bins == 538738">$ 350</div>
                            <div class="cc-item-dec" v-else-if="bins == 526144">$ 350</div>
                            <div class="cc-item-dec" v-else-if="bins == 418122">$ 350</div>
                            <div class="cc-item-dec" v-else-if="bins == 417969">$ 350</div>
                            <div class="cc-item-dec" v-else-if="bins == 485932">$ 30,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 256000">$ 2,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 486699">$ 100,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 558325">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 536025">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 545020">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 544923">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 658706">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 527375">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 529366">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 556167">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 553437">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 553370">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 519075">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 556371">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 559292">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 524897">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 534786">$ 10,000</div>
                            <div class="cc-item-dec" v-else-if="bins == 531993">$ 10,000</div>
                            <div class="cc-item-dec" v-else>$ 3,000</div>
                          </div>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol>
                          <div class="cc-item s-qu-width">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.CardOpeningFee') }}</div>
                            <div class="cc-item-dec">$ {{ kaFei2 }}</div>
                          </div>
                        </CCol>
                        <CCol style="padding-left: 0">
                          <div class="cc-item s-qu-width">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.ValueAddedRate') }}</div>
                            <div class="cc-item-dec">{{ feiLv }}</div>
                          </div>
                        </CCol>

                        <CCol style="padding-left: 0">
                          <div class="cc-item s-qu-width" style="margin-left:20px">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.ConfirmedScenario') }}</div>
                            <img @click="toUrl(bins)" style="width:22px;margin-left:10px;cursor:pointer" src="../../assets/list.png" />
                          </div>
                        </CCol>

                        <!-- <CCol> 
                          <div class="cc-item s-qu-width">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.ApplicableMerchant') }}</div>
                            <div class="cc-item-dec">
                              Facebook/TikTok
                              <el-tooltip class="item" effect="dark" content="Facebook/TikTok/ADS/Amazon/Google" placement="top-start">
                                    <i style="cursor:pointer" class="el-icon-more"></i>
                              </el-tooltip>
                            </div>
                          </div>
                        </CCol> -->
                      </CRow>
                      <!-- <CRow style="width: 100%" v-if="bins == 472593">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                            <div class="cc-item-title">{{ $t('VirtualCard.Create.BilliongAddress') }}</div>
                            <div class="cc-item-dec">ROOM 1203, 12/F TUNG CHUN COMMERCIAL CENTRE 438 SHANGHAI STREET, KOWLOON, HONG KONG, HONG KONG, 999077</div>
                          </div>
                        </CCol>
                      </CRow> -->
                      <CRow style="width: 100%" v-if="bins == 556766">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           <el-alert type="warning" show-icon :title="$t('VirtualCard.Create.Than500Tip556766')"></el-alert>
                          </div>
                        </CCol>
                      </CRow>
                      <CRow style="width: 100%" v-if="tipVis">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           <el-alert type="warning" show-icon>
                             <template slot="title">
                               <div>{{ $t('VirtualCard.Create.Support3DTip') }}</div>
                               <div>{{ $t('VirtualCard.Create.SpendLimitPerYear') }}</div>
                               <div>{{ $t('VirtualCard.Create.Tip587_738_144_122') }}</div>
                             </template>
                           </el-alert>
                          </div>
                        </CCol>
                      </CRow>
                      <CRow style="width: 100%" v-if="bins == 428837">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           <el-alert type="warning" show-icon :title="$t('VirtualCard.Create.Tip428837')"></el-alert>
                          </div>
                        </CCol>
                      </CRow>
                      <CRow style="width: 100%" v-if="visible472_450">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           <!-- <el-alert type="warning" show-icon :title="$t('VirtualCard.Create.Tip472593')"></el-alert> -->
                           <el-alert type="warning" show-icon>
                             <template slot="title">
                               <div>{{ $t('VirtualCard.Create.Tip472593') }}</div>
                               <div v-if="bins == 450306">{{ $t('VirtualCard.Create.TipTip472593') }}</div>
                               <div v-if="bins == 446618">{{ $t('VirtualCard.Create.TipTip472593') }}</div>
                               <div v-if="bins == 493724">{{ $t('VirtualCard.Create.TipTip472593') }}</div>
                             </template>
                           </el-alert>
                          </div>
                        </CCol>
                      </CRow>
                      <!-- visible450306_486699FeeDesc -->
                      <!-- <CRow style="width: 100%" v-if="visible450306_486699FeeDesc">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           
                           <el-alert type="warning" show-icon>
                             <template slot="title">
                               <div>{{ $t('VirtualCard.Create.Tip472593') }}</div>
                               <div v-if="bins == 450306">{{ $t('VirtualCard.Create.TipTip472593') }}</div>
                             </template>
                           </el-alert>
                          </div>
                        </CCol>
                      </CRow> -->
                      <CRow style="width: 100%" v-if="bins == 540524">
                        <CCol>
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           <el-alert type="warning" show-icon :title="$t('VirtualCard.Create.Tip428837')"></el-alert>
                          </div>
                        </CCol>
                      </CRow>
                      <!-- 每个卡段的description -->
                      <CRow style="width:100%" v-if="binDescription != ''">
                        <CCol>
                          
                          <div class="cc-item s-qu-width" style="width:100%;white-space:normal">
                           <el-alert type="warning" show-icon :title="binDescription"></el-alert>
                          </div>
                        </CCol>
                      </CRow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </transition-group>
            <div style="margin-top:1rem" v-if="visiOpNo472">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card428837.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card428837.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card428837.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.Commonsituation') }}</p>

                <p v-if="isDAF_222929_222934_557271" style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.Authorizationamountless222929_222934_557271') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card428837.Condition') }}</p> -->
                <p v-if="isDAF_222929_222934_557271">{{ $t('VirtualCard.Create.Card428837.AuthorizationamountlessFee222929_222934_557271') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <!--  -->
                <p v-if="isUs">{{ $t('VirtualCard.Create.Card428837.AuthCXContent4254') }}</p>
                <p v-else>{{ $t('VirtualCard.Create.Card428837.AuthCXContent2') }}</p>
                <!--  -->
              </CAlert>
            </div>
            <!-- <div style="margin-top:1rem" v-if="visible450306_486699FeeDesc">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card472593.Otherfees') }}</p>
                <hr>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent2') }}</p>
              </CAlert>
            </div> -->
            <div style="margin-top:1rem" v-if="visible472_450">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card472593.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card472593.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card472593.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card472593.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card472593.Commonsituation') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card472593.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card472593.Fee2') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent2') }}</p>
              </CAlert>
            </div>
            <div style="margin-top:1rem" v-if="bins == 556766 ? true : false">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card556766.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card556766.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card556766.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card556766.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card556766.Commonsituation') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card556766.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card556766.Fee2') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card556766.ForeignTransactionFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card556766.ForeignTransactionFeeDec') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent2') }}</p>
              </CAlert>
            </div>
            <div style="margin-top:1rem" v-if="bins == 485932 ? true : false">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card485932.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card485932.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card485932.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card485932.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card485932.Commonsituation') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card485932.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card485932.Fee2') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card485932.ForeignTransactionFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card485932.ForeignTransactionFeeDec') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent2') }}</p>
              </CAlert>
            </div>

            <!--  -->
            <div style="margin-top:1rem" v-if="fee404038_559666_556150">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card404038_559666_556150.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Commonsituation') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card404038_559666_556150.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Fee2') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card404038_559666_556150.ForeignTransactionFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.ForeignTransactionFeeDec') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.AuthCXContent2') }}</p>
              </CAlert>
            </div>

            <!--  -->
            <div style="margin-top:1rem" v-if="fee111111_441112_531993_534786_524897_559292_556371_519075_553370">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card404038_559666_556150.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Commonsituation') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card404038_559666_556150.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.Fee2') }}</p>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card404038_559666_556150.ForeignTransactionFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.ForeignTransactionFeeDec') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card404038_559666_556150.AuthCXContent2') }}</p>
              </CAlert>
            </div>

            <!-- fee658706_55616741_553437 -->
            <div style="margin-top:1rem" v-if="fee658706_55616741_553437">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card658_556_553.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card658_556_553.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Commonsituation') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card658_556_553.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Fee2') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card658_556_553.AuthCXContent2') }}</p>
              </CAlert>
            </div>
            <!-- fee558325_545020 -->
            <div style="margin-top:1rem" v-if="fee558325_545020">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card558325_545020.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card558325_545020.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card558325_545020.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card558325_545020.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card558325_545020.Commonsituation') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card558325_545020.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card558325_545020.Fee2') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card558325_545020.AuthCXContent2') }}</p>
              </CAlert>
            </div>

            <div style="margin-top:1rem" v-if="fee527375_544923">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card658_556_553.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card658_556_553.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card658_556_553.Commonsituation') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card544923_527375.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card544923_527375.Fee2') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card658_556_553.AuthCXContent2') }}</p>
              </CAlert>
            </div>

            <div style="margin-top:1rem" v-if="bins == 256000 ? true : false">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card25600.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card25600.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card25600.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card25600.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card25600.Commonsituation') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card25600.Authorizationamountless') }} <span class="mc-bd" v-if="noMtf != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card25600.Fee2') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card428837.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card428837.AuthCXContent1') }}</p>
                <p>{{ $t('VirtualCard.Create.Card25600.AuthCXContent2') }}</p>
              </CAlert>
            </div>

            <div style="margin-top:1rem" v-if="tipVis">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card587_738_144_122.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.AuthorizationDeclinedDesc') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card587_738_144_122.AuthorizationAmount') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.AuthorizationAmountDesc') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card587_738_144_122.ForeignTransactionFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.ForeignTransactionFeeDesc') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card587_738_144_122.CardRefund') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.CardRefundDesc') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.CardRefundFee') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card587_738_144_122.IdleManagementFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.IdleManagementFeeDesc') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.Fee') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card587_738_144_122.TransactionRefund') }}</p>
                <p>{{ $t('VirtualCard.Create.Card587_738_144_122.TransactionRefundDesc') }}</p>
              </CAlert>
            </div>

            <!--  -->
            <div style="margin-top:1rem" v-if="mapType.includes('S')">
              <CAlert color="dark" v-bind:visible="true">
                <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.Otherfees') }}</p>
                <hr>
                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.AuthorizationDeclined') }} <span class="mc-bd" v-if="noDeclineFee != 0">{{$t('Dashboard.Exempted')}}</span></p>
                <!-- <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.Condition') }}</p> -->
                <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.Fee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.Commonsituation') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.AuthorizationRate') }}</p>
                <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.Fee2') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.AuthCXTitle') }}</p>
                <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.AuthCXContent1') }}</p>

                <p style="font-weight: bold">{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.ForeignTransactionFee') }}</p>
                <p>{{ $t('VirtualCard.Create.Card491090_556167_483317_476715_447420_433451_428836_404038.ForeignTransactionFeeDec') }}</p>
              </CAlert>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    <!-- 账户余额不足弹窗 -->
    <div>
      <el-dialog
      :visible.sync="dialogVisibleNoAccount"
      :close-on-click-modal="false"
      :show-close="false"
      width="30%">
        <el-alert type="warning" :title="$t('VirtualCard.Create.AccountBalanceDialog.DTitle')"></el-alert>
        <span slot="footer" class="dialog-footer">
        <div style="margin-top:10px">
          <el-button class="qxclass" @click="dialogVisibleNoAccount = false">{{ $t('VirtualCard.Create.AccountBalanceDialog.DBtn2') }}</el-button>
          <el-button style="background:#00BEA4;color:#fff" type="primary" @click="goToDepositPage">{{ $t('VirtualCard.Create.AccountBalanceDialog.DBtn1') }}</el-button>
        </div>
      </span>
      </el-dialog>
    </div>
    <!-- 支付保證金彈窗 -->
    <div>
      <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="30%">
      <span slot="title">
        <el-alert type="warning">
          <div slot="title">
            <!-- <div>{{ $t('VirtualCard.Create.GuaranteeDialog.DialogTitleTip') }}</div> -->
            <div>{{$t('VirtualCard.Create.GuaranteeDialog.NewDialogTitleTip')}} <span style="font-weight:bold;">{{$t('VirtualCard.Create.GuaranteeDialog.FontWeightTip5')}}</span></div>
            <!-- <div>428837 / 540524 / 222929 / 222934 / 472593 / 557271 / 485932 / 404038 / 559666 / 556150</div> -->
            <!-- <div style="padding:5px 0">
              <span>{{ $t('VirtualCard.Create.GuaranteeDialog.UpdateTo5') }}</span>
              <span>428837 / 540524 / 222929 / 222934 / 472593 / 557271 / 485932 / 404038 / 556150 / 559666 / 441112 / 524897</span>
            </div> -->
            <!-- <div>
              <span>{{ $t('VirtualCard.Create.GuaranteeDialog.UpdateTo10') }}</span>
              <span>529587 / 538738 / 526144 / 418122 / 417969</span>
            </div> -->
          </div>
        </el-alert>
      </span>
      <span>{{ $t('VirtualCard.Create.GuaranteeDialog.GuaranteeDeposit') }}</span><span style="font-weight:bold">$100</span>
      
      <span slot="footer" class="dialog-footer">
        <div style="text-align:left">
          <el-alert>
          <div slot="title">
            <div>{{ $t('VirtualCard.Create.GuaranteeDialog.DialogFooterTip1') }}</div>
            <div>{{ $t('VirtualCard.Create.GuaranteeDialog.DialogFooterTip2') }}</div>
          </div>
        </el-alert>
        </div>
        <div style="margin-top:10px">
          <el-button class="qxclass" @click="dialogVisible = false">{{ $t('VirtualCard.Create.GuaranteeDialog.Cancel') }}</el-button>
          <el-button style="background:#00BEA4;color:#fff" type="primary" @click="payNow">{{ $t('VirtualCard.Create.GuaranteeDialog.PayNow') }}</el-button>
        </div>
      </span>
    </el-dialog>
    </div>
    <!-- 选择持卡人窗口 -->
    <div>
      <el-dialog
      :visible.sync="selectCardHolderDialog"
      :close-on-click-modal="false"
      :show-close="true"
      width="53%">
      <CardHolderTable :useSelect="true" @onSelected="hanlderSelectedCardHolder"></CardHolderTable>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { CForm, CFormInput } from "@coreui/vue";
import card428837 from "../../assets/428837.png"
import card222929 from "../../assets/222929.png"
import card222929New from "../../assets/222929-new.webp"
// import webp1 from "../../assets/428837.webp"
import webp1 from "../../assets/newcard/428837.png"
// import webp2 from "../../assets/472593.webp"
import webp2 from "../../assets/newcard/472593.png"
// import webp3 from "../../assets/222929-new.webp"
import webp3 from "../../assets/newcard/222929.png"
// import webp4 from "../../assets/556766.webp"
import webp4 from "../../assets/newcard/556766.png"
import mc from "../../assets/mc.png"
import discovericon from "../../assets/discover.png"
import card557271 from "../../assets/newcard/557271.png"
import card540524 from "../../assets/newcard/540524.png"
import card222934 from "../../assets/newcard/222934.png"
import card529587 from '../../assets/newcard/529587.png'
import card538738 from '../../assets/newcard/538738.png'
import card526144 from '../../assets/newcard/526144.png'
import card418122 from '../../assets/newcard/418122.png'
import card417969 from '../../assets/newcard/417969.png'
import card485932 from '../../assets/newcard/485932.png'
import card404038 from '../../assets/newcard/404038.png'
import card559666 from '../../assets/newcard/559666.png'
import card556150 from '../../assets/newcard/556150.png'
import card450306 from '../../assets/newcard/450306.png'
import cardguangziyi from '../../assets/newcard/111111_441122_531993_534786_524897_559292_556371_519075_553370guangziyi.png'
import IsChildren from '../../components/IsChildren.vue'
import {getCardInfo, getPageNotice, guaranteeDeposit,getCardBinInfo} from "../../api/http"
import MyAddInput from "../../components/MyAddInput.vue"
import { Loading } from "element-ui";
import CardNumPrj from "../../components/CardNumPrj.vue"
import TextScroll from "../../components/TextScroll.vue"
import CardHolderTable from '../../components/CardHolderTable.vue'
export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    fields: {
      type: Array,
      default() {
        //   ['充值金額', '開卡費', '充值費用', '總計']
        return [
          {
            key: "Amount",
            label: "充值金額",
          },
          {
            key: "CardFei",
            label: "開卡費",
          },
          {
            key: "AmountFei",
            label: "充值費用",
          },
          {
            key: "Tatol",
            label: "總計",
          },
        ];
      },
    },
    caption: {
      type: String,
      default: "Table",
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
  },
  components: {
    CForm,
    CFormInput,
    IsChildren,
    MyAddInput,
    CardNumPrj,
    TextScroll,
    CardHolderTable
  },
  data() {
    return {
      errorBackName556766: "",
      errorBackNameL556766: "",
      submitDib2: false,
      checkedRlus: false,
      inputVal: [
        {
          value: '20',
          label: '持卡人姓名',
          isLastItem: true
        }
      ],
      ival: {
        first_name: "",
        last_name: ""
      },
      textArr: [
        // {
        //   id: 1,
        //   val: "特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！特大优惠！！！"
        // },
        // {
        //   id: 2,
        //   val: "特大喜讯！！！"
        // },
        // {
        //   id: 3,
        //   val: "mmmmm！！！"
        // }
      ],
      preList: [require('../../assets/485932_tip_img.png')],
      barr: [529587,538738,526144,418122,417969,472593,222929,222934,557271,428837,540524,556766],
      xzarr:[
        // {}
        // {
        //   bin: [],
        //   description: ""
        // }
      ],
      isVis: false,
      addData: [
        {
          first_name: "",
          last_name: "",
          balance: "10.00",
          // initAmt: 20.00,
          tag: "",
          // holder_name: '',
          holder_name_label: '',
          billing_address: {
            address: "",
            city: "",
            state: "AL",
            zip: ""
            // zip: ""
          }
        }
      ],
      wOption: ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'],
      ctNum: "",
      remaining: null,
      ifAddMax: true,
      card428837,
      card222929,
      card222929New,
      card529587,
      card538738,
      card526144,
      card418122,
      card417969,
      card485932,
      card404038,
      card559666,
      card556150,
      card450306,
      cardguangziyi,
      itemIndex: 0,
      // bins: 428837,
      bins: '',
      is4725: false,
      webp1,
      webp2,
      webp3,
      webp4,
      card557271,
      card540524,
      card222934,
      mc,
      discovericon,
      errorBack: "",
      FirstName: "",
      lastName: "",
      options: ["428837", "222929"],
      selectCard: "",
      Amount: 20.0,
      errorBackAmount: "",
      errorBackOrderAddress: "",
      errorBackAmount556766: "",
      errorBackAmount587_738_144_122: "",
      submitDib587_738_144_122: false,
      tag: "",
      errorBackTag: "",
      //   AmountFei: 0,
      feiLv: "0.00000",
      kaFei: null,
      kaFei2: null,
      imgEle: undefined,
      initBalance: null,
      img1: "",
      img2: '',
      stateOp: "",
      feiNum: null,
      submitDib: false,
      flg: false,
      flg2: false,
      allFlg: false,
      allLastFlg: false,
      ori: "",
      dialogVisible: false,
      binRegion: 'AllRegion',
      binBrand: 'AllBrand',
      binObj: {
        binRegion: 'AllRegion',
        binBrand: 'AllBrand',
      },
      allVisi: true,
      usBin: false,
      hkBin: false,
      visaBin: false,
      masterBin: false,
      hds: false,
      kq: false,
      mapType: [],
      // 筛选中的
      searching: false,
      ztArr: [
        {
          ty: 'HK',
          hkarr: [529587,538738,526144,418122,417969,472593,222929,222934,557271,658706,527375,544923,558325,545020]
        },
        {
          ty: 'US',
          usarr: [428837,540524,556766,485932,559666,556150,404038,111111,441112,531993,534786,524897,559292,556371,519075,553370,553437,556167,491090,483317,476715,447420,433451,428836,486699,536025,529366]
        },
        {
          ty: 'SGP',
          sgparr: [450306, 446618]
        },
        {
          ty: 'UK',
          ukarr: [256000]
        },
        {
          ty: 'VISA',
          visaarr: [418122,417969,472593,428837,485932,404038,450306,111111,441112,491090,483317,476715,447420,433451,428836,486699,446618]
        },
        {
          ty: 'Master',
          masterarr: [529587,538738,526144,222929,222934,540524,556766,559666,556150,531993,534786,524897,559292,556371,519075,553370,553437,556167,256000,536025,558325,545020,527375,544923,529366]
        },
        {
          ty: 'Discover',
          discoverarr: [658706]
        },
        {
          ty: 'HK_VISA',
          hk_visa_arr: [418122,472593]
        },
        {
          ty: 'HK_Master',
          hk_master_arr: [529587,538738,526144,417969,222929,222934,557271,527375,544923,558325,545020]
        },
        {
          ty: 'US_VISA',
          us_visa_arr: [428837,485932,404038,111111,441112,491090,483317,476715,447420,433451,428836,486699]
        },
        {
          ty: 'US_Master',
          us_master_arr: [540524,556766,559666,556150,531993,534786,524897,559292,556371,519075,553370,553437,556167,536025,529366]
        },
        {
          ty: 'US_Discover',
          us_discover_arr: []
        },
        {
          ty: 'HK_Discover',
          hk_discover_arr: [658706]
        },
        {
          ty: 'SGP_Discover',
          sgp_discover_arr: []
        },
        {
          ty: 'SGP_VISA',
          sgp_visa_arr: [450306,446618]
        },
        {
          ty: 'SGP_Master',
          sgp_master_arr: []
        },
        {
          ty: 'UK_Master',
          uk_master_arr: [256000]
        },
        {
          ty: 'UK_VISA',
          uk_visa_arr: []
        },
        {
          ty: 'UK_Discover',
          uk_discover_arr: []
        }
      ],
      binArrObj: [],
      visiBinTip: false,
      vsBtip: false,
      need_guarantee: 1,
      account_balance: null,
      dialogVisibleNoAccount: false,
      binDescription: '',
      supportCardHolder: '',
      selectCardHolderDialog: false,
      holder_name: '',
      createCardItem: {},
      ccIndex: 0,
      data: [
        {
          Amount: 20,
          CardFei: 20,
          AmountFei: 20,
          Tatol: 20,
        },
      ],
    };
  },
  computed: {
    cardMap() {
      return {
        556766: { src: this.webp4, radius: true },
        428837: { src: this.webp1 },
        472593: { src: this.webp2 },
        222929: { src: this.webp3, radius: true },

        222934: { src: this.card222934, radius: true },
        540524: { src: this.card540524, radius: true },
        557271: { src: this.card557271, radius: true },
        529587: { src: this.card529587, radius: true },
        538738: { src: this.card538738, radius: true },
        526144: { src: this.card526144, radius: true },
        418122: { src: this.card418122, radius: true },
        417969: { src: this.card417969, radius: true },
        485932: { src: this.card485932, radius: true },
        404038: { src: this.card404038, radius: true },
        559666: { src: this.card559666, radius: true },
        556150: { src: this.card556150, radius: true },

        // 多 BIN 共用同一張圖
        450306: { src: this.card450306, radius: true },
        446618: { src: this.card450306, radius: true },
        493724: { src: this.card450306, radius: true },

        // 光子易卡
        111111: { src: this.cardguangziyi, radius: true },
        441112: { src: this.cardguangziyi, radius: true },
        531993: { src: this.cardguangziyi, radius: true },
        534786: { src: this.cardguangziyi, radius: true },
        524897: { src: this.cardguangziyi, radius: true },
        559292: { src: this.cardguangziyi, radius: true },
        556371: { src: this.cardguangziyi, radius: true },
        519075: { src: this.cardguangziyi, radius: true },
        553370: { src: this.cardguangziyi, radius: true },
        658706: { src: this.cardguangziyi, radius: true },
        553437: { src: this.cardguangziyi, radius: true },
        536025: { src: this.cardguangziyi, radius: true },
        558325: { src: this.cardguangziyi, radius: true },
        545020: { src: this.cardguangziyi, radius: true },
        527375: { src: this.cardguangziyi, radius: true },
        544923: { src: this.cardguangziyi, radius: true },

        256000: { src: this.webp4, radius: true },

        // 特殊卡
        491090: { src: this.card404038, radius: true },
        483317: { src: this.card404038, radius: true },
        476715: { src: this.card404038, radius: true },
        447420: { src: this.card404038, radius: true },
        433451: { src: this.card404038, radius: true },
        428836: { src: this.card404038, radius: true },

        486699: { src: this.webp2 },

        // 新服务卡BIN
        529366: { src: this.cardguangziyi, radius: true },
      }
    },
    currentCard() {
      const map = this.cardMap

      let card = map[this.bins]

      // 特殊邏輯
      if (this.bins == 556167) {
        return {
          src: this.mapType.includes('S')
            ? this.card404038
            : this.cardguangziyi,
          radius: true
        }
      }

      return card || null
    },
    // 子賬戶標志 2為子賬戶
    primaryMark() {
      return this.$store.state.primary_mark
    },
    noMtf() {
      return localStorage.getItem('no_mtf')
    },
    noDeclineFee() {
      return localStorage.getItem('no_decline_fee')
    },
    // bins() {
    //   if(this.binArrObj.length !== 0) {
    //     return this.binArrObj[0].bin
    //   }else{
    //     return 472593
    //   }
      
    // },
    // visiTipBin() {
    //   if(this.binArrObj.length !== 0) {
    //     this.binArrObj.forEach((item) => {
    //       if(item.description !== null || item.description !== '') {
    //         return true
    //       }else {
    //         return false
    //       }
    //     })
    //   }
    // },
    cardType() {
      if(this.bins == 222929 || this.bins == 222934 || this.bins == 529587 || this.bins == 538738 || this.bins == 526144 || this.bins == 418122 || this.bins == 417969 || this.bins == 111111 || this.bins == 441112 || this.bins == 531993 || this.bins == 534786 || this.bins == 524897 || this.bins == 559292 || this.bins == 556371 || this.bins == 519075 || this.bins == 553370 || this.bins == 553437 || this.bins == 658706 || this.bins == 556167) {
        return "Foton Card"
      }else{
        return "Foton Card"
      }
    },
    cb() {
      let str = this.bins + ''
      // return str.slice(0,4)
      // return this.searching == true ? "" : str.slice(0,4)
      if(this.kq == true) {
        // return setTimeout(() => {str.slice(0,4)},1500)
        return str.slice(0,4)
      }else if(this.searching == true) {
        return ""
      }
      else{
        return str.slice(0,4)
      }
    },
    // cb: {
    //   get() {
    //     let str = this.bins + ''
    //     return this.searching == true ? "" : str.slice(0,4)
    //   },
    //   set(e) {
    //     let str = this.bins + ''
    //     return this.searching == true ? "" : str.slice(0,4)
    //     return e
    //   }
    // },
    c2b() {
      let str = this.bins + ''
      // return str.slice(4)
      // return this.searching == true ? "" : str.slice(0,4)
     if(this.kq == true) {
        // return setTimeout(() => {str.slice(0,4)},1500)
        return str.slice(4)
      }else if(this.searching == true) {
        return ""
      }
      else{
        return str.slice(4)
      }
    },
    // 是否为visa图标
    picBin() {
      let str = this.bins + ''
      if(str.includes(472593) || str.includes(428837) || str.includes(418122) || str.includes(417969) || str.includes(485932) || str.includes(404038) ||str.includes(450306) || str.includes(111111) || str.includes(441112) ||str.includes(491090) ||str.includes(483317) ||str.includes(476715) || str.includes(447420) || str.includes(433451) || str.includes(428836) || str.includes(486699) || str.includes(446618)) {
        return true
      }
      // else if(str.includes(55616741)) {
      //   return true
      // }
      else {
        return false
      }
      
    },
    tipVis() {
      if(this.bins == 529587 || this.bins == 538738 || this.bins == 526144 || this.bins == 418122 || this.bins == 417969) {
        return true
      }else {
        return false
      }
    },
    visible450306_486699FeeDesc() {
      if(this.bins == 450306 || this.bins == 486699 || this.bins == 446618 || this.bins == 493724) {
        return true
      }else{
        return false
      }
    },
    visible472_450() {
      if(this.bins == 472593 || this.bins == 450306 || this.bins == 486699 || this.bins == 446618 || this.bins == 493724) {
        return true
      }else{
        return false
      }
      // if(this.bins == 472593) {
      //   return true
      // }else{
      //   return false
      // }
    },
    // 其他涉及费用
    fee404038_559666_556150() {
      if(this.bins == 404038 || this.bins == 559666 || this.bins == 556150) {
        if(this.bins == 404038 && this.mapType.includes("S")) {
          return false
        }
        return true
      }else{
        return false
      }
    },
    // 其他涉及费用
    fee111111_441112_531993_534786_524897_559292_556371_519075_553370() {
      if(this.bins == 111111 || this.bins == 441112 || this.bins == 531993 || this.bins == 534786 || this.bins == 524897 || this.bins == 559292 || this.bins == 556371 || this.bins == 519075 || this.bins == 553370) {
        return true
      }else{
        return false
      }
    },
    fee658706_55616741_553437() {
      // if(this.bins == 658706 || this.bins == 556167 || this.bins == 553437 || this.bins == 536025 || this.bins == 558325 || this.bins == 545020) {
      //   if(this.bins == 556167 && this.mapType.includes("S")) {
      //     return false
      //   }
      //   return true
      // }else{
      //   return false
      // }
      if(this.bins == 658706 || this.bins == 556167 || this.bins == 553437 || this.bins == 536025) {
        if(this.bins == 556167 && this.mapType.includes("S")) {
          return false
        }
        return true
      }else{
        return false
      }
    },
    fee558325_545020() {
      if(this.bins == 558325 || this.bins == 545020) {
        if(this.bins == 556167 && this.mapType.includes("S")) {
          return false
        }
        return true
      }else{
        return false
      }
    },
    fee527375_544923() {
      if(this.bins == 527375 || this.bins == 544923 || this.bins == 529366) {
        return true
      }else {
        return false
      }
    },
    toMer() {
      // return `${this.ori}/detail-list/#/?bins=${this.bin}&uid=${window.localStorage.getItem('uid')`
      let uid = window.localStorage.getItem('uid')
      let bin = this.bins
      let url = this.ori
      return url+'/detail-list/#/?bins='+bin+'&uid='+uid
    },
    dType() {
      // 491090,483317,476715,447420,433451,428836
      if(this.bins == 556766 || this.bins == 540524 || this.bins == 559666 || this.bins == 556150) { 
        return "Master (US)"
      }
      if(this.bins == 428837 || this.bins == 485932 || this.bins == 404038 || this.bins == 491090 || this.bins == 483317 || this.bins == 476715 || this.bins == 447420 || this.bins == 433451 || this.bins == 428836) {
        return "VISA（US）"
      }
      if(this.bins == 472593) {
        return "VISA（HK)"
      }
      if(this.bins == 222929 || this.bins == 222934 || this.bins == 529587 || this.bins == 538738 || this.bins == 526144 || this.bins == 527375 || this.bins == 544923) {
        return "Master（HK）"
      }
      if(this.bins == 418122 || this.bins == 417969) {
        return "VISA（HK）"
      }
      if(this.bins == 450306 || this.bins == 446618) {
        return "VISA（SGP)"
      }
      if(this.bins == 111111 || this.bins == 441112 || this.bins == 486699) {
        return "VISA (US)"
      }
      if(this.bins == 531993 || this.bins == 534786 || this.bins == 524897 || this.bins == 559292 || this.bins == 556371 || this.bins == 519075 || this.bins == 553370 || this.bins == 553437 || this.bins == 556167 || this.bins == 536025 || this.bins == 529366) {
        return "Master (US)"
      }
      if(this.bins == 658706) {
        return "Discover (HK)"
      }
      if(this.bins == 256000) {
        return "Master (UK)"
      }
      else {
        return "Master（HK）"
      }
    },
    // 输入框
    visiOp() {
      if(this.bins == 428837 || this.bins == 222929 || this.bins == 222934 || this.bins == 540524 || this.bins == 557271 || this.bins == 472593 || this.bins == 485932 || this.bins == 404038 || this.bins == 559666 || this.bins == 556150 || this.bins == 450306 || this.bins == 111111 || this.bins == 441112 || this.bins == 531993 || this.bins == 534786 || this.bins == 524897 || this.bins == 559292 || this.bins == 556371 || this.bins == 519075 || this.bins == 553370 || this.bins == 553437 || this.bins == 658706 || this.bins == 556167 || this.bins == 256000 || this.bins == 491090 || this.bins == 483317 || this.bins == 476715 || this.bins == 447420 || this.bins == 433451 || this.bins == 428836 || this.bins == 486699 || this.bins == 536025 || this.bins == 558325 || this.bins == 545020 || this.bins == 527375 || this.bins == 544923 || this.bins == 446618 || this.bins == 493724 || this.bins == 529366) {
        return true
      }else {
        return false
      }
    },
    visiOpNo472() {
      if(this.bins == 428837 || this.bins == 222929 || this.bins == 222934 || this.bins == 540524 || this.bins == 557271) {
        return true
      }else {
        return false
      }
    },
    getI18nLocale() {
      return this.$i18n.locale
    },
    isDAF_222929_222934_557271() {
      if(this.bins == 222934 || this.bins == 222929 || this.bins == 557271) {
        return true
      }else{
        return false
      }
    },
    isUs() {
      if(this.getI18nLocale == 'en') {
        if(this.bins == 428837 || this.bins == 540524) {
          return true
        }else {
          return false
        }
      }else {
        return false
      }
    },
    getLa() {
      // return localStorage.getItem("lang")
      let la = this.$i18n.locale
      if(la == 'en') {
        return 'en-US'
      }else {
        return this.$i18n.locale
      }
    },
    AmountFei: {
      //  充值金额*充值费率

      get() {
        let res = this.toPoint(this.feiLv);
        console.log("res==>", res);
        return (this.AmountFei = (Number(this.Amount) * res).toFixed(2));
      },
      set() {
        console.log("11");
      },
    },
    Tatol() {
      return (
        Number(this.Amount) +
        Number(this.kaFei) +
        Number(this.AmountFei)
      ).toFixed(2);
    },
    getAmount: {
      // return Number(val).toFixed(2)
      get: function () {
        // let vd = Number(this.Amount).toFixed(2)
        // let vd = Number(this.Amount)
        let vd = null
        // let ad = 20
        this.addData.forEach((item) => {
          // vd = item.balance
          vd += Number(item.balance)
          console.log('item.balance', item.balance)
        })
        return this.Amount = Number(vd).toFixed(2)
        // console.log('ad===>', ad)
        // return Number(this.Amount).toFixed(2);
      },
      set: function (val) {
        let num = Number(val).toFixed(2);
        console.log(num);
        this.Amount = num;
      },
    },
  },
  beforeCreate() {
    // 预加载图片
    // this.$axios({
    //   url: "/card/card.json",
    //   method: "GET"
    // }).then(res => {
    //   console.log('imres==>', res)
    //   this.img1 = res.data.data.card222929
    // })
  },
  created() {
    
    this.Amount = Number(this.Amount).toFixed(2);
    this.ori = window.location.origin
    this.getBin()
    // this.bins = this.binArrObj.length == 0 ? 472593 : this.binArrObj[0].bin
    // this.getInfo()
    // this.bins = this.binArrObj[0].bin
    
    // this.getAnnouncement()
  },
  mounted() {
    // this.bins = this.binArrObj.length == 0 ? 472593 : this.binArrObj[0].bin
  },
  watch: {
    addData(va) {
      if(va.length == 5) {
        this.ifAddMax = false
      }else {
        this.ifAddMax = true
        // this.kaFei + va.length
        console.log('val==>', va.length)
        console.log('kaFei==>', this.kaFei)
        // debugger
        // this.feiNum = Number(this.kaFei) * Number(this.addData.length)
        this.kaFei = Number(this.feiNum) * Number(this.addData.length)
        // debugger
        console.log('ka-->', this.kaFei, this.feiNum)
        // debugger
        // this.kaFei = feiNum
      }
    },
    bins(e) {
      console.log('bins e ==>', e)
      if(e==428837 || e==222929) {
        // this.is4725 = true
        this.is4725 = false
      }
      if(e == 472593 || e == 222934 || e == 540524 || e == 557271) {
        this.is4725 = false
      }
      if(e !== 556766) {
        this.flg = false
        this.flg2 = false
      }
      else {
        this.is4725 = false
      }
    },
    binObj: {
      handler(e) {
        console.log('eeeee==>', e)
        // this.itemIndex = this.itemIndex
        // this.itemIndex = 0
        
        this.searching = true
        this.xzarr = []
        // this.kq = true
        if(e.binRegion == 'US' && e.binBrand == 'VISA') {
          console.log('us-visa')
          let us_visa = this.ztArr.filter((item) => {return item.ty == 'US_VISA'})
          // this.xzarr = us_visa[0].us_visa_arr
          us_visa[0].us_visa_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: us_visa[0].us_visa_arr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }else if(e.binRegion == 'US' && e.binBrand == 'Master') {
          console.log('us-master')
          let us_master = this.ztArr.filter((item) => {return item.ty == 'US_Master'})
          // this.xzarr = us_master[0].us_master_arr
          us_master[0].us_master_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: us_master[0].us_master_arr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }
        
        else if(e.binRegion == 'US' && e.binBrand == 'Discover') {
          // console.log('us-master')
          let us_discover = this.ztArr.filter((item) => {return item.ty == 'US_Discover'})
          // this.xzarr = us_master[0].us_master_arr
          us_discover[0].us_discover_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'HK' && e.binBrand == 'Discover') {
          // console.log('us-master')
          let hk_discover = this.ztArr.filter((item) => {return item.ty == 'HK_Discover'})
          // this.xzarr = us_master[0].us_master_arr
          hk_discover[0].hk_discover_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'SGP' && e.binBrand == 'Discover') {
          // console.log('us-master')
          let sgp_discover = this.ztArr.filter((item) => {return item.ty == 'SGP_Discover'})
          // this.xzarr = us_master[0].us_master_arr
          sgp_discover[0].sgp_discover_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'HK' && e.binBrand == 'VISA') {
          console.log('hk-visa')
          let hk_visa = this.ztArr.filter((item) => {return item.ty == 'HK_VISA'})
          // this.xzarr = hk_visa[0].hk_visa_arr
          hk_visa[0].hk_visa_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: hk_visa[0].hk_visa_arr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }else if(e.binRegion == 'HK' && e.binBrand == 'Master') {
          console.log('hk-master')
          this.xzarr = []
          let hk_master = this.ztArr.filter((item) => {return item.ty == 'HK_Master'})
          // this.xzarr = hk_master[0].hk_master_arr
          hk_master[0].hk_master_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: hk_master[0].hk_master_arr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }
        else if(e.binRegion == 'SGP' && e.binBrand == 'VISA') {
          console.log('sgp-visa')
          let sgp_visa = this.ztArr.filter((item) => {return item.ty == 'SGP_VISA'})
          // this.xzarr = sgp_visa[0].sgp_visa_arr
          sgp_visa[0].sgp_visa_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'SGP' && e.binBrand == 'Master') {
          console.log('sgp-master')
          let sgp_master = this.ztArr.filter((item) => {return item.ty == 'SGP_Master'})
          // this.xzarr = sgp_master[0].sgp_master_arr
          sgp_master[0].sgp_master_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'UK' && e.binBrand == 'Master') {
          let uk_master = this.ztArr.filter((item) => {return item.ty == 'UK_Master'})
          // this.xzarr = uk_master[0].uk_master_arr
          uk_master[0].uk_master_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'UK' && e.binBrand == 'VISA') {
          let uk_visa = this.ztArr.filter((item) => {return item.ty == 'UK_VISA'})
          // this.xzarr = uk_visa[0].uk_visa_arr
          uk_visa[0].uk_visa_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'UK' && e.binBrand == 'Discover') {
          let uk_discover = this.ztArr.filter((item) => {return item.ty == 'UK_Discover'})
          // this.xzarr = us_master[0].us_master_arr
          uk_discover[0].uk_discover_arr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'HK') {
          console.log('hk')
          let hk = this.ztArr.filter((item) => {return item.ty == 'HK'})
          // this.xzarr = hk[0].hkarr
          hk[0].hkarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.binArrObj.forEach((item) => {
          //   this.xzarr.push({
          //     description: item.description,
          //     bin: hk[0].hkarr.map((item) => {return item})
          //   })
          // })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: hk[0].hkarrr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }else if(e.binRegion == 'US') {
          this.xzarr = []
          console.log('us')
          let us = this.ztArr.filter((item) => {return item.ty == 'US'})
          // this.xzarr = us[0].usarr
          us[0].usarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: us[0].usarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }
        else if(e.binRegion == 'SGP') {
          this.xzarr = []
          console.log('sgp')
          let sgp = this.ztArr.filter((item) => {return item.ty == 'SGP'})
          // this.xzarr = us[0].usarr
          sgp[0].sgparr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binRegion == 'UK') {
          this.xzarr = []
          let uk = this.ztArr.filter((item) => {return item.ty == 'UK'})
          // this.xzarr = us[0].usarr
          uk[0].ukarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binBrand == 'VISA') {
          console.log('visa')
          this.xzarr = []
          let visa = this.ztArr.filter((item) => {return item.ty == 'VISA'})
          // this.xzarr = visa[0].visaarr
          visa[0].visaarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: visa[0].visaarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }
        else if(e.binBrand == 'Discover') {
          console.log('discover')
          this.xzarr = []
          let discover = this.ztArr.filter((item) => {return item.ty == 'Discover'})
          // this.xzarr = visa[0].visaarr
          // this.xzarr.push({
          //       description: null,
          //       bin: 658706,
          //       is_maintain: 0,
          //       tip_visi: false
          //     })
          discover[0].discoverarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }

        else if(e.binBrand == 'Master') {
          console.log('master')
          let master = this.ztArr.filter((item) => {return item.ty == 'Master'})
          // this.xzarr = master[0].masterarr
          master[0].masterarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: master[0].masterarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }else if(e.binRegion == 'AllRegion' &&e.binBrand == 'VISA') {
          console.log('visa')
          let visa = this.ztArr.filter((item) => {return item.ty == 'VISA'})
          // this.xzarr = visa[0].visaarr
          visa[0].visaarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: visa[0].visaarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }else if(e.binRegion == 'AllRegion' &&e.binBrand == 'Master') {
          console.log('master')
          let master = this.ztArr.filter((item) => {return item.ty == 'Master'})
          // this.xzarr = master[0].masterarr
          console.log("master", master)
          master[0].masterarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: master[0].masterarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }
        else if(e.binRegion == 'AllRegion' &&e.binBrand == 'Discover') {
          this.xzarr = []
          let discover = this.ztArr.filter((item) => {return item.ty == 'Discover'})
          // this.xzarr = visa[0].visaarr
          console.log("discover", discover)
          
          discover[0].discoverarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binBrand == 'AllBrand' &&e.binRegion == 'US') {
          console.log('us')
          let us = this.ztArr.filter((item) => {return item.ty == 'US'})
          // this.xzarr = us[0].usarr
          us[0].usarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: us[0].usarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }else if(e.binBrand == 'AllBrand' &&e.binRegion == 'HK') {
          console.log('hk')
          let hk = this.ztArr.filter((item) => {return item.ty == 'HK'})
          // this.xzarr = hk[0].hkarr
          hk[0].hkarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
          // this.xzarr.push({
          //     description:this.binArrObj.map(item => {return item.description}),
          //     bin: hk[0].hkarr,
          //     is_maintain: this.binArrObj.map(item => {return item.is_maintain}),
          //     tip_visi: this.binArrObj.map(item => {return item.tip_visi})
          //   })
        }
        else if(e.binBrand == 'AllBrand' &&e.binRegion == 'SGP') {
          console.log('allbrand sgp')
          let sgp = this.ztArr.filter((item) => {return item.ty == 'SGP'})
          // this.xzarr = sgp[0].sgparr
          sgp[0].sgparr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binBrand == 'AllBrand' &&e.binRegion == 'UK') {
          let uk = this.ztArr.filter((item) => {return item.ty == 'UK'})
          // this.xzarr = uk[0].ukarr
          uk[0].ukarr.forEach((item) => {
            this.binArrObj.forEach((d) => {
              if(item == d.bin) {
                this.xzarr.push({
                description: d.description,
                bin: item,
                is_maintain: d.is_maintain,
                tip_visi: d.tip_visi
              })
              }
            })
          })
        }
        else if(e.binBrand == 'AllBrand' && e.binRegion == 'AllRegion') {
          this.allVisi = true
          this.searching = false
          this.kq = false
        }
        else{
          // this.allVisi = true
        }
      },
      immediate: true,
      deep: true
    }
    // binObj(e) {
    //   if(e.binRegion == 'US' && e.binBrand == 'VISA') {
    //     console.log('czczczc')
    //   }
    // }
  },
  methods: {
    imageStyle(card) {
      return {
        width: '543px',
        height: '280px',
        borderRadius: card.radius ? '10px' : ''
      }
    },
    // 卡bin名称显示
    binNameRender(item) {
      // item.bin == '472593' ? '4367**' : item.bin
      if(item.bin == '472593') {
        return '4367**'
      }else if(item.bin == '486699') {
        return '4866**'
      }else if(item.bin == '450306') {
        return '4*****'
      }
      else if(item.bin == '446618') {
        return '4466**'
      }
      else{
        return item.bin
      }
    },
    // 打开选择持卡人窗口
    openSelectCardHolderDialog(item, index) {
      this.selectCardHolderDialog = true
      this.createCardItem = item
      this.ccIndex = index
    },
    // 清除已選中的持卡人
    resetCardHolder(item,index) {
      console.log('item', item)
      // this.$set(this.addData[index], 'holder_name', item?.id)
      delete this.addData[index]?.card_holder;
      this.$set(this.addData[index], 'holder_name_label', '')
    },
    // 回调被选中的持卡人
    hanlderSelectedCardHolder(item) {
      console.log('item', item)
      this.holder_name = item?.holder_name
      this.selectCardHolderDialog = false
      this.$set(this.addData[this.ccIndex], 'card_holder', item?.id)
      this.$set(this.addData[this.ccIndex], 'holder_name_label', item?.holder_name)
    },
    // 去往账户充值页
    goToDepositPage() {
      this.$router.push({
        path: '/funds/funds'
      })
    },
    // 光子易卡bin img
    isGuangziyiCard() {
      if(this.bins == 111111 || this.bins == 441112 || this.bins == 531993 || this.bins == 534786 || this.bins == 524897 || this.bins == 559292 || this.bins == 556371 || this.bins == 519075 || this.bins == 553370) {
        return true
      }else{
        return false
      }
    },
    // visiTipBin() {
    //   if(this.binArrObj.length !== 0) {
    //     this.binArrObj.forEach((item) => {
    //       if(item.description !== null || item.description !== '') {
    //         console.log('122')
    //         this.vsBtip = true
    //       }else {
    //         console.log('211')
    //         this.vsBtip = false
    //       }
    //     })
    //   }
    // },
    // 獲取卡Bin
    getBin() {
      let data = {
        type: 'get_card_bin_info',
        uid: localStorage.getItem('uid')
      }
      getCardBinInfo(data).then((res) => {
        console.log('getBin-===>', res)
        this.binArrObj = res.data
        this.bins = this.binArrObj[0].bin
        this.getInfo(res.data[0].bin, true)
        this.mapType = this.binArrObj.map(item => item.type)
        this.supportCardHolder = res.data[0]?.support_card_holder

        // if(res.code == 200) {
        //   // 打开账户余额不足窗口
        //   setTimeout(() => {
        //     if(this.account_balance < this.Tatol) {
        //       this.dialogVisibleNoAccount = true
        //     }
        //   }, 1000)
        // }
        
        // this.bins = res.data.length == 0 ? 472593 : res.data[0].bin
        this.binArrObj.forEach((item) => {
          this.$set(item, 'showPopper', false)
          // if(item.description === null) {
          //   // this.$set(item,'tip_visi',false)
          //   this.$set(item, 'showPopper', false)
          // }else{
          //   // this.$set(item,'tip_visi',true)
          //   this.$set(item, 'showPopper', true)
          // }
        })
        this.getCardDescription()
        if(this.binArrObj[0].description===null) {
          this.$set(this.binArrObj[0], 'showPopper', false)
        }else{
          this.$set(this.binArrObj[0], 'showPopper', true)
        }
      })
    },
    descriptionInfoShow(item) {
      var descs = ''
      if(this.getLa === 'en-US') {
        descs = item?.description || ''
      } else {
        descs = item?.description_cn || ''
      }

      return descs;
    },
    // 鼠标移入卡BIN显示tip
    visiTipHan(index,item) {
      if(this.binArrObj) {
        console.log('moseover',index,item)
        if(this.getLa == 'en-US') {
          if(item.description != null) {
            this.$set(item,'tip_visi',true)
          } else {
            this.$set(item,'tip_visi',false)
          }
        } else{
          if(item.description_cn != null) {
            this.$set(item,'tip_visi',true)
          } else {
            this.$set(item,'tip_visi',false)
          }
        }
        // if(item.bin == '450306') {
        //   this.$set(item,'tip_visi',true)
        // } 
        // if(item.bin == '472593') {
        //   this.$set(item,'tip_visi',true)
        // }
        // if(item.bin == '486699') {
        //   this.$set(item,'tip_visi',true)
        // }
        // this.binArrObj.forEach((item,i) => {
        //   if(index === i) {
        //     if(item.description === null) {
        //       this.$set(item,'tip_visi',false)
        //     } else if(item.description_cn === null) {
        //       this.$set(item,'tip_visi',false)
        //     }
        //     else{
        //       if(item.bin == '450306') {
        //         this.$set(item,'tip_visi',true)
        //       } 
        //       if(item.bin == '472593') {
        //         this.$set(item,'tip_visi',true)
        //       }
        //       if(item.bin == '486699') {
        //         this.$set(item,'tip_visi',true)
        //       }
        //       this.$set(item,'tip_visi',true)
        //     }
        //   }
        // })
      }
    },
    // 鼠标移入卡BIN显示tip
    visiTipHan2(index) {
      if(this.xzarr) {
        console.log('moseover')
        this.xzarr.forEach((item,i) => {
          if(index === i) {
            if(item.description === null) {
              this.$set(item,'tip_visi',false)
            } else if(item.description_cn === null) {
              this.$set(item,'tip_visi',false)
            }
            else{
              if(item.bin == '450306') {
                this.$set(item,'tip_visi',true)
              } 
              if(item.bin == '446618') {
                this.$set(item, 'tip_visi', true)
              }
              if(item.bin == '472593') {
                this.$set(item,'tip_visi',true)
              }
              if(item.bin == '486699') {
                this.$set(item,'tip_visi',true)
              }
              this.$set(item,'tip_visi',true)
            }
          }
        })
      }
    },
    // 鼠标移出卡BIN不显示tip
    hideTipHan(it,index) {
      console.log(index)
      this.$set(it,'tip_visi',false)
    },
    // 新标签页打开清单
    // https://test.fotoncard.com/detail-list/#/?bins=428837
    toUrl(bin) {
      // window.open(`https://test.fotoncard.com/detail-list/#/?bins=${bin}`, "_blank")
      // window.open(`/request/detail-list/#/?bins=${bin}`, "_blank")
      // window.open(`https://test.fotoncard.com/detail-list/#/?bins=${bin}`, "_blank")
      // console.log("process.env.NODE_ENV", process.env.NODE_ENV)
      console.log("wd=>", window.location.origin)
      // dev
      if(this.ori.indexOf("https://test.fotoncard.com") > -1) {
        window.open(`https://test.fotoncard.com/detail-list/#/?bins=${bin}&uid=${window.localStorage.getItem('uid')}`, "_blank")
      }
      // UAT
      if(this.ori.indexOf("https://uatdash.fotoncard.com") > -1) {
        window.open(`https://uatdash.fotoncard.com/detail-list/#/?bins=${bin}&uid=${window.localStorage.getItem('uid')}`, "_blank")
      }
      // live
      if(this.ori.indexOf("https://dashboard.fotoncard.com") > -1) {
        window.open(`https://dashboard.fotoncard.com/detail-list/#/?bins=${bin}&uid=${window.localStorage.getItem('uid')}`, "_blank")
      }
      if(this.ori.indexOf("http://localhost:8085") > -1) {
        window.open(`http://localhost:8085/detail-list/#/?bins=${bin}&uid=${window.localStorage.getItem('uid')}`, "_blank")
      }
      else {
        console.log("11")
        // window.open(`https://test.fotoncard.com/detail-list/#/?bins=${bin}`, "_blank")
        //  window.open(`https://uatdash.fotoncard.com/detail-list/#/?bins=${bin}`, "_blank")
      }
    },
    inputChange (val, index) {
      // 相应改变items数组对应index元素的数据
    },
    // 选择地区触发相应的卡bin
    handlerBinRegion(e) {
      console.log('region===>', e)
      this.xzarr = []
      if(e == 'US') {
        this.allVisi = false
        // this.hkBin = false
        // this.usBin = true
        // let usto = this.ztArr.filter((item) => {return item.ty == 'US'})
        // this.xzarr = usto[0].usarr
      }else if(e == 'HK') {
        this.allVisi = false
        // this.usBin = false
        // this.hkBin = true
        // let hkto = this.ztArr.filter((item) => {return item.ty == 'HK'})
        // this.xzarr = hkto[0].hkarr
      }else if(e == 'SGP') {
        this.allVisi = false
        // this.usBin = false
        // this.hkBin = true
        // let hkto = this.ztArr.filter((item) => {return item.ty == 'HK'})
        // this.xzarr = hkto[0].hkarr
      }
      else if(e == 'UK') {
        this.allVisi = false
      }
      else if(this.binBrand=="VISA" || this.binRegion =="US") {
        // this.xzarr.push(428837)
        console.log('123123')
      }
      else{
        // this.allVisi = true
      }
    },
    // 选择品牌触发相应的卡bin
    handlerBinBrand(e) {
      console.log('brand===>', e)
      this.xzarr = []
      if(e == 'VISA') {
        this.allVisi = false
        // this.visaBin = true
        // this.masterBin = false
        // this.xzarr.push(418122,417969,472593,428837)
      }else if(e == 'Master') {
        this.allVisi = false
        // this.visaBin = false
        // this.masterBin = true
        // this.xzarr.push(529587,538738,526144,222929,222934,540524,556766)
      }else if(e == 'Discover') {
        this.allVisi = false
      }
      else{
        // this.allVisi = true
      }
    },
    addItem () {
      // 相应改变items数组，push一个元素
      // this.inputVal.push(
      //   {
      //     value: '',
      //     label: '',
      //     isLastItem: true
      //   }
      //   )
      // this.addData.push({
      //   first_name: "",
      //   last_name: "",
      //   initAmt: 20.00,
      //   tag: ""
      // })
      this.getAddInfo()
      
      // console.log('this.addData.length', this.addData.length + 1)
      // this.kaFei = this.kaFei * this.addData.length
      
    },
    deleteItem (index) {
      // 相应删除items数组对应index元素的数据
      console.log('index==>', index)
      this.addData.splice(index, 1)
    },
    // 點擊支付保證金
    showDig() {
      this.dialogVisible = true
    },
    // 現在支付
    payNow() {
      let tm = null
      let data = {
        type: 'guarantee_deposit',
        uid: localStorage.getItem('uid')
      }
      guaranteeDeposit(data).then((res) => {
        if(res.code == 200) {
          this.dialogVisible = false
          this.$message.success(res.message)
          clearTimeout(tm)
          tm = setTimeout(() => {location.reload()},1500)
        }else {
          this.$message.error(res.message)
        }
      })
    },
    getOption(val) {
      console.log("vals==>", val)
      let e = val.target.value
      this.addData.forEach((item) => {
        item.billing_address.state = e
      })
    },
    // 请求通告数据
    getAnnouncement(noticeType) {
      let obj = {
        uid: window.localStorage.getItem("uid"),
        type: "get_page_notice",
        // page: "fund_fund"
        page: noticeType
      }
      getPageNotice(obj).then((res) => {
        console.log("notice==>", res)
        if(res.code == 200) {
          if(res.data.length !== 0) {
            this.isVis = true
            this.textArr = res.data
          }else {
            this.isVis = false
          }
        }
      })
    },
    getAddInfo(num) {
      let data = {
        type: "create_card_info",
        uid: window.localStorage.getItem("uid"),
        bin: this.bins || num,
      }
      getCardInfo(data).then(res => {
        console.log('res==>', res)
        // let adr = []
        let bin_info = res.data.bin_info
        // this.FirstName = res.data.name.first_name
        // this.lastName = res.data.name.last_name
        if(this.bins == 556766) {
            this.addData.push({
            first_name: res.data.name.first_name,
            last_name: res.data.name.last_name,
            balance: bin_info.init_balance,
            // holder_name: '',
            tag: "",
            billing_address: {
              address: res.data.billing_address.address,
              city: res.data.billing_address.city,
              state: res.data.billing_address.state,
              zip: res.data.billing_address.zip
            }
          })
        }
        else{
          this.addData.push({
          first_name: res.data.name.first_name,
          last_name: res.data.name.last_name,
          balance: bin_info.init_balance,
          // holder_name: '',
          tag: "",
          billing_address: {
              address: "",
              city: "",
              state: "AL",
              zip: ""
            }
        })
        }
        this.Amount = bin_info.init_balance
        
        // console.log('num', num)
      })
    },
    getInfo(num, isFirst = false) {
      let data = {
        type: "create_card_info",
        uid: window.localStorage.getItem("uid"),
        bin: this.bins || num,
      }
      getCardInfo(data).then(res => {
        console.log('res==>', res)
        // let adr = []
        let bin_info = res.data.bin_info
        // this.FirstName = res.data.name.first_name
        // this.lastName = res.data.name.last_name
        // this.addData.push({
        //   first_name: res.data.name.first_name,
        //   last_name: res.data.name.last_name,
        //   initAmt: bin_info.init_balance,
        //   tag: ""
        // })
        this.addData[0].first_name = res.data.name.first_name
        this.addData[0].last_name = res.data.name.last_name
        this.addData[0].balance = bin_info.init_balance
        this.addData[0].tag = ""
        this.initBalance = bin_info.init_balance
        
        // this.addData[0].billing_address.address = res.data.billing_address.address
        this.addData.forEach((item) => {
          if(this.bins == 556766) {
            item.billing_address.address = res.data.billing_address.address
            item.billing_address.city = res.data.billing_address.city
            item.billing_address.state = res.data.billing_address.state
            item.billing_address.zip = res.data.billing_address.zip
          }
        })
        // if(this.bins == 556766) {
        //     this.addData[0].billing_address = {
        //     address: res.data.billing_address.address
        //   }
        // }

        this.Amount = bin_info.init_balance
        this.kaFei = bin_info.card_fee
        this.kaFei2 = bin_info.card_fee
        this.feiNum = bin_info.card_fee
        this.ctNum = bin_info.issue_limit
        this.remaining = bin_info.remaining
        this.feiLv = this.toPercent(bin_info.topup_rate)
        this.need_guarantee = res.data.need_guarantee
        // 账户余额
        this.account_balance = res.data.account_balance

        if(isFirst) {
          // 子賬戶不顯示賬戶餘額不足
          if(res.data.account_balance < this.Tatol && this.primaryMark != '2') {
            this.dialogVisibleNoAccount = true
          }
        }
        
      })
    },
    // 百分比轉爲小數
    toPoint(percent) {
      var str = percent.replace("%", "");
      //   console.log('str==>', str)
      str = str / 100;
      return str;
    },
    // 小数转百分比显示
    toPercent(point) {
      if (!point || Math.abs(point) < 0.0001) { // 小于0.0001的都认为是0
        return "0%";
      }
      return (point * 100).toFixed(2) + "%";
    },
  //   toPercent(point){
  //   if (point==0) {
  //     return 0;
  //   }
  //   var str=Number(point*100).toFixed(2);
  //   str+="%";
  //   return str;
  // },
    getSelectCard(e) {
      this.selectCard = e.target.value;
    },
    validatorName556766(val) {
      let regEn = /[^\a-\z\A-\Z]/g;
      if (val) {
        if (regEn.test(val)) {
          this.errorBack = this.$t('VirtualCard.Create.InvalidName');
          return false;
        }
        if(val.length < 4) {
          this.errorBackName556766 = this.$t('VirtualCard.Create.FLTip');
          this.submitDib2 = true
          this.flg2 = true
          return false
        }
        if (val.length > 15) {
          this.errorBack = this.$t('VirtualCard.Create.InvalidName');
          return false;
        } else {
          this.errorBack = "";
          this.submitDib2 = false
          this.flg2 = false
          return true;
        }
      }
      else{
        this.errorBackName556766 = this.$t('VirtualCard.Create.FLTip');
        this.flg2 = true
        this.submitDib2 = true
        // this.flg2 = true
        // this.submitDib2 = true
        return false
      }
      // else {
      //     this.errorBack = this.$t('VirtualCard.Create.InvalidName');
      //     this.submitDib = true
      //     return false;
      // }
    },
    validatorNameL556766(val) {
      let regEn = /[^\a-\z\A-\Z]/g;
      if (val) {
        if (regEn.test(val)) {
          this.errorBack = this.$t('VirtualCard.Create.InvalidName');
          return false;
        }
        if(val.length < 4) {
          this.errorBackNameL556766 = this.$t('VirtualCard.Create.FLTip');
          this.flg = true
          this.submitDib2 = true
          return false
        }
        if (val.length > 15) {
          this.errorBack = this.$t('VirtualCard.Create.InvalidName');
          return false;
        } else {
          this.errorBack = "";
          this.submitDib2 = false
          this.flg = false
          return true;
        }
      }
      else{
        this.errorBackNameL556766 = this.$t('VirtualCard.Create.FLTip');
        this.flg = true
        this.submitDib2 = true
        // this.flg2 = true
        // this.submitDib2 = true
        return false
      }
      // else {
      //     this.errorBack = this.$t('VirtualCard.Create.InvalidName');
      //     this.submitDib = true
      //     return false;
      // }
    },
    // 持卡人表單驗證
    validator(val) {
      let regEn = /[^\a-\z\A-\Z]/g;
      if (val) {
        if (regEn.test(val)) {
          this.errorBack = this.$t('VirtualCard.Create.InvalidName');
          // this.flg = false
          // this.flg2 = false
          // this.submitDib2 = false
          this.allFlg = true
          this.submitDib = true
          return false;
        }
        if (val.length > 15) {
          this.errorBack = this.$t('VirtualCard.Create.InvalidName');
          // this.flg = false
          // this.flg2 = false
          // this.submitDib2 = false
          this.allFlg = true
          this.submitDib = true
          return false;
        } else {
          this.errorBack = "";
          this.allFlg = false
          this.submitDib = false
          return true;
        }
      }else{
        this.errorBack = this.$t('VirtualCard.Create.FLTip');
        // this.flg = true
        // this.flg2 = true
        // this.submitDib2 = true
        this.allFlg = true
        this.submitDib = true
        return false
      }
    },
    // 充值金額驗證
    validatorAmount(val) {
      let regNum = /^\.+|[^\d.]/g;

      let str = val.toString();

      var len1 = str.substr(0, 1);

      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉

      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');
        return false;
      }
      //第一位不能是.

      if (len1 == "." && regNum.test(len1)) {
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');

        str = "";
        return false;
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);

        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }

        if (str_.length > 2) {
          this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');

          str = "";
          return false;
        }
      }

      if (regNum.test(val)) {
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');
        return false;
      }
      if(Number(val) < Number(this.initBalance)) {
        this.errorBackAmount = this.$t('VirtualCard.Create.InitialBalanceTip') + this.initBalance
        this.submitDib = true
        return false;
      }
      // if(this.bins == 556766) {
      //     if(Number(val) < 10) {
      //     this.errorBackAmount = "初始餘額不能小於$10"
      //     return false;
      //   }
      // }
      
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
      this.submitDib = false
      return true;
      // if (regNum.test(val)) {
      //   this.errorBackAmount = "僅允許輸入正數";
      //   return false;
      // } else {
      //   this.errorBackAmount = "";
      //   return true;
      // }
    },
    validatorAmount556766(val){
      let regNum = /^\.+|[^\d.]/g;

      let str = val.toString();

      var len1 = str.substr(0, 1);

      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉

      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');
        return false;
      }
      //第一位不能是.

      if (len1 == "." && regNum.test(len1)) {
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');

        str = "";
        return false;
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);

        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }

        if (str_.length > 2) {
          this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');

          str = "";
          return false;
        }
      }

      if (regNum.test(val)) {
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');
        return false;
      }
      if(Number(val) < Number(this.initBalance)) {
        this.errorBackAmount556766 = this.$t('VirtualCard.Create.InitialBalanceTip556766') + this.initBalance;
        this.submitDib2 = true
        return false;
      }
      if(Number(val) > 500) {
        this.errorBackAmount556766 = this.$t('VirtualCard.Create.Than500')
        this.submitDib2 = true
        return false
      }
      // if(this.bins == 556766) {
      //     if(Number(val) < 10) {
      //     this.errorBackAmount = "初始餘額不能小於$10"
      //     return false;
      //   }
      // }
      
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
      this.submitDib2 = false
      return true;
    },
    validatorAmount587_738_144_122(val) {
      let regNum = /^\.+|[^\d.]/g;

      let str = val.toString();

      var len1 = str.substr(0, 1);

      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉

      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');
        return false;
      }
      //第一位不能是.

      if (len1 == "." && regNum.test(len1)) {
        this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');

        str = "";
        return false;
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);

        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }

        if (str_.length > 2) {
          this.errorBackAmount = this.$t('VirtualCard.Create.InvalidAmount');

          str = "";
          return false;
        }
      }

      if (regNum.test(val)) {
        this.errorBackAmount587_738_144_122 = this.$t('VirtualCard.Create.InvalidAmount');
        return false;
      }
      if(Number(val) < Number(this.initBalance)) {
        this.errorBackAmount587_738_144_122 = this.$t('VirtualCard.Create.InitialBalanceTip556766') + this.initBalance;
        this.submitDib587_738_144_122 = true
        return false;
      }
      if(Number(val) > 350) {
        this.errorBackAmount587_738_144_122 = this.$t('VirtualCard.Create.Than350')
        this.submitDib587_738_144_122 = true
        return false
      }
      
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
      this.submitDib587_738_144_122 = false
      return true;
    },
    // 標簽長度驗證
    validatorTag(val) {
      if (val) {
        if (val.length > 20) {
          this.errorBackTag = this.$t('VirtualCard.Create.InvalidTag');
          return false;
        } else {
          this.errorBackTag = "";
          return true;
        }
      }
    },
    // 賬單地址
    validatorOrderAddress(val) {
      // let regAddress = /[\u4E00-\u9FA5]/g;
      // if(regAddress.test(val)) {
      //   this.errorBackOrderAddress = "不允许输入中文"
      //   return false
      // } else {
      //   this.errorBackOrderAddress = ""
      //   return true
      // }
    },
    // 提交创建卡
    submit() {
      // console.log("submit");
      
      if(this.flg || this.flg2 || this.allFlg) {
        this.$message.warning(this.$t('VirtualCard.Create.FLTip'))
        return;
      }
      if(this.checkedRlus == false) {
        this.$message.warning(this.$t('VirtualCard.Create.SelectedRlus.NoRlusTip'))
        return;
      }
      // 验证支付保证金 子賬戶不需要顯示支付保證金
      if(this.need_guarantee === 1 && this.primaryMark != '2') {
        this.dialogVisible = true
        return;
      }
      // 验证账户余额 子賬戶不需要顯示賬戶餘額不足
      if(this.account_balance < this.Tatol && this.primaryMark != '2') {
        this.dialogVisibleNoAccount = true
        return;
      }
      let loading = Loading.service({ fullscreen: true });
      let obj = {
        type: "issue_card",
        uid: localStorage.getItem('uid'),
        bin: this.bins,
        card_info: JSON.stringify(this.addData)
        // card_info: this.addData
      }
      // let str = JSON.stringify(this.addData)
      // this.$axios.post('/request/user.php', {
      //       type: "issue_card",
      //       uid: localStorage.getItem('uid'),
      //       bin: this.bins,
      //       card_info: JSON.stringify(this.addData)
      //   }).then((res) => {
      //   if(res.data.code == 200) {
      //     loading.close()
      //     this.$message.success(res.data.message)
      //   }else if(res.data.code == 401) {
      //     loading.close()
      //     this.$message.warning(res.data.message)
      //     this.$router.push("/pages/login")
      //   }
      //   else{
      //     loading.close()
      //     this.$message.error(res.data.message)
      //   }
      // })
      //  let formData = new FormData();
      // for (let k in obj) {
      //   formData.append(k, obj[k]);
      // }
      // 忽略掉holder_name_label
      const filteredCardData = this.addData.map(({ holder_name_label, ...rest }) => rest);
      this.$axios({
        method: "POST",
        url: `/request/user.php?type=issue_card&uid=${localStorage.getItem('uid')}&bin=${this.bins}`,
        // url: `/request/user.php`,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        // data: formData,
        data: JSON.stringify(filteredCardData),
        // data: {
        //   // type: "issue_card",
        //   // uid: localStorage.getItem('uid'),
        //   // bin: this.bins,
        //   card_info: JSON.stringify(this.addData)
        // },
      }).then((res) => {
        if(res.data.code == 200) {
          loading.close()
          this.$message.success(res.data.message)
          // this.getInfo()
          this.$router.push("/virtual-card/card-list")
        }else if(res.data.code == 401) {
          loading.close()
          this.$message.warning(res.data.message)
          this.$router.push("/pages/login")
        }
        else{
          loading.close()
          // this.$message.error(res.data.message)
          this.$message({
          type: "error",
          message: res.data.message,
          duration: 5000
        });
        }
      })
    },
    handlerBtn() {
      
    },
    // 获取每个卡段的描述
    getCardDescription() {
      var desc = ''
      const currentBinInfo = this.binArrObj.filter(item => item.bin === this.bins)
      if(currentBinInfo && currentBinInfo.length != 0) {
        if(this.getLa === 'en-US') {
          desc = currentBinInfo[0]?.description || ''
        } else {
          desc = currentBinInfo[0]?.description_cn || ''
        }
      }
      
      this.binDescription = desc
    },
    getIndex(e,n, item) {
      console.log('eee==>', e)
      console.log('nnnn=>', n)
      console.log("it", item)
      
      
      setTimeout(() => {
        if(this.searching == true) {
        this.kq = true
      }
      },1500)
      this.kq = false
      // this.searching = false
      this.itemIndex = e
      this.bins = n
      this.getInfo(n)
      this.addData = [
        {
          first_name: "",
          last_name: "",
          balance: 10.00,
          // initAmt: 20.00,
          tag: "",
          billing_address: {
            address: "",
            city: "",
            state: "AL",
            zip: ""
          }
        }
      ]
      if(this.itemIndex == 0) {
        let wbox = this.$refs.wbox
        // wbox.addClss('')
        console.log('wbo==>', wbox)
      }
      this.getCardDescription()
      this.supportCardHolder = this.binArrObj[e]?.support_card_holder
      // setTimeout(() => {
      //   if(item?.description === null) {
      //     this.$set(item, 'showPopper', false)
      //     console.log("null")
      //   }else{
      //     this.$set(item, 'showPopper', true)
      //     console.log("string")
      //   }
      // }, 0)
      
    }
  },
  
};
</script>
<style scoped lang="scss">
.mc-bd {
  padding: .3rem .5rem;
  background: #dff6e6;
  margin-left: .5rem;
  border-radius: 5px;
}
.acc-balancebox {
  margin-bottom: .3rem;
  display:flex;
  align-items:center;
  justify-content:space-between;
  border-bottom:1px solid rgba(0,0,21,.125);
  padding: 8px 0;
}
.add-card-item-border {
  width: 100%;
  height: 1px;
  background-color: #DFDFE2;
  margin-right: 5px;
  margin-top: 5px;
}
.sup-pos{
  width: 12px;
  height: 12px;
  position: absolute;
  left: 59px;
  top: 1px;
}
.search-bin-box{
  display: flex;
  margin-bottom: 10px;
}
.qxclass:hover{
  background-color: #00bea41c;
  color: #00BEA4
}
.pst-box{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 888;
}
.cc-title{
    font-size: 35px;
    color: #fff;
    font-weight: bold;
    margin-left: 48px;
    margin-top: 18px;
}
.cc-number{
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-top: 45px;
    margin-left: 48px;
    margin-bottom: 20px;
}
.cc-time{
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-left: 290px;
    margin-top: -10px;
}
.cc-name{
    color: #fff;
    font-size: 27px;
    font-weight: bold;
    margin-left: 47px;
    // margin-top: -15px;
}
.visa-ico{
  margin-left: 366px;
  margin-top: -53px;
  // position: absolute;
  // top: 156px;
  // left: 366px;
}
.visa-ico2{
  position: absolute;
  top: 156px;
  left: 366px;
}
.gund{
  animation: 12s linear 0s normal infinite gunds;
}
@keyframes gunds {
  0%{
    margin-top: 0;
  }
  // 15%{
  //   margin-top: 0;
  // }
  // 25%{
  //   margin-top: -40px;
  // }
  // 40%{
  //   margin-top: -40px;
  // }
  50%{
    margin-top: -40px;
  }
  // 65%{
  //   margin-top: -80px;
  // }
  // 75%{
  //   margin-top: -40px;
  // }
  // 85%{
  //   margin-top: -40px;
  // }
  100%{
    margin-top: 0px;
  }
}
.pst-rl{
  position: relative;
}
// label{
//   font-weight: bold;
// }
.ft{
  font-weight: bold !important;
}
.adt{
    background: #E0E2E6;
    font-size: 12px;
    padding: 0.1rem 0.5rem;
    font-weight: bold;
}
.sbtn:hover{
  background: rgba(0,190,164, .8) !important;
}
.sbtn:focus{
  border-color: #00BEA4;
  box-shadow: 0 0 0 .25rem rgba(0,190,164, .5) !important;
}
.custer{
  background: #00bea4;
  color: #fff; 
  width: 100%;
  outline:0;
}
/*  */
.cur{
  outline: none;
  border: none;
  color: #00BEA4;
  background: transparent;
  padding: 6px 12px;
  font-weight: bold;
}
.hv:hover{
  background: rgb(0,190,164);
  color: #fff;
  border-radius: 0.375rem;
}
.hv:focus{
  background: rgb(0,190,164);
  color: #fff;
  border-radius: 0.375rem;
}
.inpt{
  margin-top: .6rem;
  margin-bottom: .6rem;
}
.card-create-box{
  overflow: hidden;
}
.cc-box {
  padding: 20px 0;
  background: #fff;
  .cc-title-box {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 1.4rem;
      color: #212121;
    }
  }

  .cc-input-box {
    margin-top: 10px;
    width: 534px;
    color: #878787;
    width: 100%;
    .cc-ka-box {
      display: flex;
      //   align-items: center;
    }
    .fei-box {
      font-weight: bold;
      padding-bottom: 5px;
      border-bottom: 1px solid #dfdfe2;
    }
    .fei-info-box {
      padding: 10px 0;
    }
  }
}
.cc-info-box {
  .cc-with-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
    // width: 534px;
    margin: 0 auto;
    .cc-item {
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: 20px;
      // padding-right: 85px;
      // margin-right: 50px;
      .cc-item-title {
        font-size: 14px;
        color: #a3a3a3;
      }
      .cc-item-dec {
        color: #898989;
        font-weight: bold;
      }
    }
  }
}
.card-img {
  width: 100%;
  height: 100%;
}
.s-btn-box{
  margin-bottom: 10px;
}
.yd-text{
  display: block;
  // width: 118px;
  // animation: move 12s linear infinite;
}
@keyframes move {
  0%{
    transform: translateX(0);
  }
  50%{
    transform: translateX(-100px);
  }
  100%{
    transform: translateX(100px);
  }
}
.s-btn {
  width: 75px;
  overflow: hidden;
  outline: 0;
  border: 0;
  padding: 0.4rem 0.9rem;
  color: #4C4C5B;
  margin-left: 15px;
  background: #FFF;
  border-radius: 8px;
  border: 1px solid #f1f1f2;
}
.xc{
  margin-bottom: 10px;
}
// .xc:nth-child(4) {
//   margin-left: 0;
// }
// .xc:nth-child(5) {
//   margin-left: 0;
// }
// .xc:nth-child(9) {
//   margin-left: 0;
// }
.s-btn-active {
  background: #00bea4;
  color: #fff;
}

.tomerchant{
  vertical-align: 1px;
  color: #1675d4;
}

@media screen and (max-width: 520px){
    .s-qu-width{
      width: 0;
    }
  }
</style>
<style>
.popper-sty{
  color: #fff !important;
  background: rgba(0,0,0,0.9) !important;
}
.el-dialog{
  border-radius: 8px !important;
}
</style>